{
	"dialog.ok": "OK",
	"dialog.cancel": "Cancelar",
	"dialog.confirm": "Confirmar",
	"dialog.close": "Fechar",
	"dialog.import": "Importar",
	"dialog.save": "Salvar",
	"dialog.discard": "Discartar",
	"dialog.dontshowagain": "Não mostrar de novo",
	"data.cube": "Cubo",
	"data.group": "Grupo",
	"data.texture": "Textura",
	"data.plugin": "Plug-in",
	"data.preview": "Pré-visualização",
	"data.toolbar": "Barra de ferramentas",
	"data.image": "Imagem",
	"keys.ctrl": "Ctrl",
	"keys.shift": "Shift",
	"keys.alt": "Alt",
	"keys.meta": "Cmd",
	"keys.delete": "Deletar",
	"keys.space": "Espaço",
	"keys.leftclick": "Clique esquerdo",
	"keys.middleclick": "Clique do meio",
	"keys.rightclick": "Clique direito",
	"keys.tab": "Tab",
	"keys.backspace": "Backspace",
	"keys.enter": "Enter",
	"keys.escape": "Esc",
	"keys.function": "F%0",
	"keys.numpad": "Numérico %0",
	"keys.caps": "Caps Lock",
	"keys.menu": "Menu de contexto",
	"keys.left": "Esquerda",
	"keys.up": "Cima",
	"keys.right": "Direita",
	"keys.down": "Baixo",
	"keys.pageup": "página para cima",
	"keys.pagedown": "página para baixo",
	"keys.plus": "Mais",
	"keys.comma": "Vírgula",
	"keys.point": "Ponto",
	"keys.minus": "Menos",
	"keys.cross": "Mais",
	"keys.end": "End",
	"keys.pos1": "Pos 1",
	"keys.printscreen": "Print",
	"keys.pause": "Pause",
	"message.rotation_limit.title": "Limites de rotação",
	"message.rotation_limit.message": "As rotações no Minecraft são limitadas a um eixo e incrementos de 22.5 graus. Rotacionar em um eixo diferente irá limpar todas as rotações nos outros eixos. Converta o modelo para \"Modelo Genérico\" se estiver modelando para outros propósitos e precisar de rotações livres.",
	"message.file_not_found.title": "Arquivo não encontrado",
	"message.file_not_found.message": "O Blockbench não pôde encontrar o arquivo solicitado. Verifique se ele está salvo localmente e não em uma nuvem.",
	"message.screenshot.title": "Captura de tela",
	"message.screenshot.clipboard": "Área de transferência",
	"message.screenshot.right_click": "Captura de tela - Botão direito do mouse para copiar",
	"message.invalid_file.title": "Arquivo inválido",
	"message.invalid_file.message": "Não foi possível abrir o arquivo JSON: %0",
	"message.invalid_model.title": "Arquivo de modelo inválido",
	"message.invalid_model.message": "Este arquivo não contém dados de modelo válidos.",
	"message.child_model_only.title": "Modelo derivado vazio\n",
	"message.child_model_only.message": "Este arquivo é derivado de %0 e não contém nenhum modelo.",
	"message.unsaved_textures.title": "Texturas não salvas",
	"message.unsaved_textures.message": "Seu modelo tem texturas que ainda não foram salvas. Certifique-se de salvá-las e colá-las na pasta correta do seu pacote de recursos.",
	"message.model_clipping.title": "Modelo muito grande",
	"message.model_clipping.message": "Seu modelo tem %0 cubos maiores que o limite de 3x3x3 permitido pelo Minecraft, e por isso não irá funcionar.",
	"message.loose_texture.title": "Importar textura",
	"message.loose_texture.message": "A textura importada não faz parte de um pacote de recursos. O Minecraft só pode carregar texturas da pasta de texturas de um pacote de recursos que esteja carregado.",
	"message.loose_texture.change": "Mudar caminho",
	"message.update_res.title": "Resolução da textura",
	"message.update_res.message": "Deseja atualizar a resolução do projeto para a resolução dessa textura? Clique em 'Cancelar' se a sua textura tem uma resolução maior que o normal.",
	"message.update_res.update": "Atualizar",
	"message.bedrock_overwrite_error.message": "O Blockbench não pode combinar esse modelo com o arquivo antigo",
	"message.bedrock_overwrite_error.backup_overwrite": "Criar cópia e substituir",
	"message.bedrock_overwrite_error.overwrite": "Substituir",
	"message.close_warning.message": "Deseja salvar o seu modelo?",
	"message.close_warning.web": "O seu trabalho atual será perdido. Deseja mesmo sair?",
	"message.default_textures.title": "Texturas padrão",
	"message.default_textures.message": "Selecione a pasta \"textures\" do pacote de recursos padrão",
	"message.default_textures.detail": "Extraia o pacote de texturas padrão do jar do Minecraft, ou baixe-o da internet. Em seguida, localize e abra a pasta \"textures\". O Blockbench se lembrará desse local e tentará obter texturas a partir dele se não puder encontrá-las no pacote de recursos atual.",
	"message.default_textures.select": "Selecione a pasta \"textures\" padrão",
	"message.image_editor.title": "Selecione um editor de imagens",
	"message.image_editor.file": "Selecionar um arquivo...",
	"message.image_editor.exe": "Selecione o executável do editor de imagens",
	"message.display_skin.title": "Mostrar skin",
	"message.display_skin.message": "Selecione uma skin do seu computador ou digite o nome de um jogador",
	"message.display_skin.upload": "Carregar uma skin",
	"message.display_skin.reset": "Redefinir",
	"message.invalid_plugin": "Extensão inválida. Veja o console",
	"message.load_plugin_app": "Você quer permitir que essa extensão faça alterações no seu computador? Apenas carregue extensões de pessoas em quem você confia.",
	"message.load_plugin_web": "Você quer carregar essa extensão? Apenas carregue extensões de pessoas em quem você confia.",
	"message.preset_no_info": "A predefinição não contém informações para este espaço",
	"message.restart_to_update": "Reinicie o Blockbench para aplicar as mudanças",
	"message.save_file": "Salvo como %0",
	"dialog.project.title": "Projeto",
	"dialog.project.name": "Nome do arquivo",
	"dialog.project.parent": "Modelo de origem",
	"dialog.project.geoname": "Identificador do modelo",
	"dialog.project.ao": "Oclusão de ambiente",
	"dialog.texture.title": "Textura",
	"dialog.texture.variable": "Variável",
	"dialog.texture.namespace": "Ambiente",
	"dialog.texture.folder": "Pasta",
	"dialog.extrude.title": "Extrudar imagem",
	"dialog.extrude.mode": "Modo de digitalização",
	"dialog.extrude.mode.areas": "Áreas",
	"dialog.extrude.mode.lines": "Linhas",
	"dialog.extrude.mode.columns": "Colunas",
	"dialog.extrude.mode.pixels": "Pixels",
	"dialog.extrude.opacity": "Opacidade mínima",
	"dialog.extrude.scan": "Digitalizar e importar",
	"dialog.display_preset.title": "Criar predefinição",
	"dialog.display_preset.message": "Selecione os espaços que deseja salvar",
	"dialog.display_preset.create": "Criar",
	"dialog.select.title": "Selecionar",
	"dialog.select.group": "No grupo selecionado",
	"dialog.select.name": "O nome contém...",
	"dialog.select.random": "Aleatorizar",
	"dialog.select.select": "Selecionar",
	"dialog.scale.title": "Redimensionar modelo",
	"dialog.scale.axis": "Eixo",
	"dialog.scale.clipping": "Seu modelo é muito grande para a área de trabalho",
	"dialog.scale.confirm": "Redimensionar",
	"dialog.plugins.title": "Extensões",
	"dialog.plugins.installed": "Instaladas",
	"dialog.plugins.available": "Disponíveis",
	"dialog.plugins.install": "Instalar",
	"dialog.plugins.uninstall": "Desinstalar",
	"dialog.plugins.reload": "Recarregar",
	"dialog.plugins.none_installed": "Nenhuma extensão instalada",
	"dialog.plugins.none_available": "Nenhuma extensão disponível",
	"dialog.plugins.web_only": "Apenas para o aplicativo da web",
	"dialog.plugins.app_only": "Apenas para o aplicativo da área de trabalho",
	"dialog.plugins.author": "por %0",
	"dialog.create_texture.folder": "Pasta",
	"dialog.create_texture.resolution": "Resolução",
	"dialog.input.title": "Entrada",
	"dialog.settings.settings": "Configurações",
	"dialog.settings.keybinds": "Atalhos",
	"dialog.settings.about": "Sobre",
	"layout.color.back": "Cor de fundo",
	"layout.color.back.desc": "Planos de fundo e campos de texto",
	"layout.color.dark": "Cor escura",
	"layout.color.dark.desc": "Plano de fundo da tela",
	"layout.color.ui": "Interface",
	"layout.color.ui.desc": "Cor principal da interface",
	"layout.color.bright_ui": "Interface clara",
	"layout.color.bright_ui.desc": "Menus de contexto e dicas",
	"layout.color.button": "Botões",
	"layout.color.button.desc": "Botões e seletores",
	"layout.color.selected": "Seleções",
	"layout.color.selected.desc": "Abas e objetos selecionados",
	"layout.color.border": "Bordas",
	"layout.color.border.desc": "Bordas de botões e campos de texto",
	"layout.color.accent": "Cor de destaque",
	"layout.color.accent.desc": "Botões deslizantes e outros detalhes",
	"layout.color.grid": "Grade",
	"layout.color.grid.desc": "Grade da pré-visualização 3D",
	"layout.color.text": "Texto",
	"layout.color.text.desc": "Texto normal",
	"layout.color.light": "Cor clara",
	"layout.color.light.desc": "Texto selecionado",
	"layout.color.accent_text": "Texto em destaque",
	"layout.color.accent_text.desc": "Texto em elementos claros ou destacados",
	"layout.font.main": "Fonte principal",
	"layout.font.headline": "Fonte de títulos",
	"about.version": "Versão:",
	"settings.category.general": "Principal",
	"settings.category.preview": "Pré-visualização",
	"settings.category.grid": "Grade",
	"settings.category.edit": "Edição",
	"settings.category.snapping": "Ajuste",
	"settings.category.defaults": "Padrões",
	"settings.category.dialogs": "Diálogos",
	"settings.category.export": "Exportação",
	"settings.language": "Idioma",
	"settings.language.desc": "Idioma da interface. Reinicie o Blockbench para aplicar as alterações",
	"settings.backup_interval": "Intervalo de salvamento",
	"settings.backup_interval.desc": "Intervalo entre salvamentos automáticos (em minutos)",
	"settings.origin_size": "Origem da rotação",
	"settings.origin_size.desc": "Tamanho da origem da rotação",
	"settings.control_size": "Tamanho do controle de eixos",
	"settings.control_size.desc": "Tamanho da ferramenta de controle de 3 eixos",
	"settings.display_skin": "Mostrar skin",
	"settings.display_skin.desc": "Skin utilizada no modelo de jogador de referência de exibição",
	"settings.shading": "Sombras",
	"settings.shading.desc": "Ativar sombreamento",
	"settings.base_grid": "Grade pequena",
	"settings.base_grid.desc": "Mostrar grade pequena e eixos",
	"settings.large_grid": "Grade grande",
	"settings.large_grid.desc": "Mostrar grade de blocos 16x16",
	"settings.full_grid": "Grade completa",
	"settings.full_grid.desc": "Mostrar grade precisa em pixel",
	"settings.large_box": "Caixa grande",
	"settings.large_box.desc": "Mostrar limite de blocos 3x3x3",
	"settings.display_grid": "Modo de exibição",
	"settings.display_grid.desc": "Mostrar grade no modo de exibição",
	"settings.undo_limit": "Limite de desfazer",
	"settings.undo_limit.desc": "Número de ações que você pode desfazer",
	"settings.local_move": "Mover nos eixos relativos",
	"settings.local_move.desc": "Mover elementos rotacionados em seus próprios eixos, se possível",
	"settings.canvas_unselect": "Cancelar seleção ao clicar na tela",
	"settings.canvas_unselect.desc": "Desmarcar todos os elementos ao clicar no fundo da tela",
	"settings.paint_side_restrict": "Restringir o pincel ao lado atual",
	"settings.paint_side_restrict.desc": "Restringir os pincéis para pintar apenas no lado atual",
	"settings.autouv": "Mapeamento automático",
	"settings.autouv.desc": "Ativar mapeamento UV automático por padrão",
	"settings.create_rename": "Renomear novos cubos",
	"settings.create_rename.desc": "Selecionar o campo de nome ao criar um novo elemento ou grupo",
	"settings.edit_size": "Resolução da grade",
	"settings.edit_size.desc": "Resolução da grade à qual os cubos se encaixam",
	"settings.shift_size": "Resolução ao segurar Shift",
	"settings.shift_size.desc": "Resolução da grade ao manter Shift pressionado",
	"settings.ctrl_size": "Resolução ao segurar Ctrl",
	"settings.ctrl_size.desc": "Resolução da grade ao manter Ctrl pressionado",
	"settings.negative_size": "Tamanho negativo",
	"settings.negative_size.desc": "Permitir que a ferramenta de redimensionamento use tamanhos negativos",
	"settings.minifiedout": "Exportação simplificada",
	"settings.minifiedout.desc": "Salvar o arquivo JSON em uma única linha",
	"settings.export_groups": "Exportar grupos",
	"settings.export_groups.desc": "Salvar grupos em modelos de bloco ou item",
	"settings.credit": "Comentário de crédito",
	"settings.credit.desc": "Adicionar um comentário de crédito aos arquivos exportados",
	"settings.default_path": "Caminho Padrão de Texturas do Minecraft",
	"settings.default_path.desc": "Pasta da qual o Blockbench carrega texturas padrão",
	"settings.image_editor": "Editor de imagem",
	"settings.image_editor.desc": "Editor de imagens padrão para editar texturas",
	"category.navigate": "Navegação",
	"category.tools": "Ferramentas",
	"category.file": "Arquivo",
	"category.blockbench": "Blockbench",
	"category.edit": "Editar",
	"category.transform": "Transformar",
	"category.view": "Visualizar",
	"category.display": "Configurações de exibição",
	"category.textures": "Texturas",
	"category.misc": "Diversos",
	"keybind.preview_select": "Selecionar",
	"keybind.preview_rotate": "Rotacionar a visão",
	"keybind.preview_drag": "Arrastar a visão",
	"keybind.confirm": "Confirmar",
	"keybind.cancel": "Cancelar",
	"action.slider_inflate": "Aumentar",
	"action.slider_inflate.desc": "Aumentar cubos em todas as direções sem alterar o mapeamento.",
	"action.slider_brush_size": "Tamanho",
	"action.slider_brush_size.desc": "Tamanho do pincel (em pixels)",
	"action.slider_brush_opacity": "Opacidade",
	"action.slider_brush_opacity.desc": "Opacidade do pincel (em %)",
	"action.slider_brush_softness": "Suavidade",
	"action.slider_brush_softness.desc": "Suavidade do pincel (em %)",
	"action.uv_slider_pos_x": "Mover horizontalmente",
	"action.uv_slider_pos_x.desc": "Mover a seleção UV de todos os cubos selecionados horizontalmente",
	"action.uv_slider_pos_y": "Mover verticalmente",
	"action.uv_slider_pos_y.desc": "Mover a seleção UV de todos os cubos selecionados verticalmente",
	"action.uv_slider_size_x": "Redimensionar horizontalmente",
	"action.uv_slider_size_x.desc": "Redimensionar a seleção UV de todos os cubos selecionados horizontalmente",
	"action.uv_slider_size_y": "Redimensionar verticalmente",
	"action.uv_slider_size_y.desc": "Redimensionar verticalmente a seleção UV de todos os cubos selecionados",
	"action.vertex_snap_mode": "Modo de ajuste",
	"action.vertex_snap_mode.desc": "Seleciona se o ajuste a vértices deve mover elementos para a posição selecionada ou redimensioná-los",
	"action.move_tool": "Mover",
	"action.move_tool.desc": "Selecionar e mover elementos",
	"action.resize_tool": "Redimensionar",
	"action.resize_tool.desc": "Selecionar e redimensionar elementos",
	"action.brush_tool": "Pincel",
	"action.brush_tool.desc": "Pintar em texturas de bitmap em superfícies ou no editor de UV",
	"action.vertex_snap_tool": "Ajustar a vértices",
	"action.vertex_snap_tool.desc": "Mover um cubo para outro cubo conectando dois vértices",
	"action.swap_tools": "Trocar ferramentas",
	"action.swap_tools.desc": "Alternar entre as ferramentas de mover e redimensionar",
	"action.project_window": "Projeto...",
	"action.project_window.desc": "Abre a janela do projeto, na qual você pode editar os metadados do seu modelo",
	"action.open_model": "Abrir modelo",
	"action.open_model.desc": "Abrir um arquivo de modelo do seu computador",
	"action.extrude_texture": "Textura extrudada",
	"action.extrude_texture.desc": "Gerar um modelo a partir do esticamento de uma textura",
	"action.export_blockmodel": "Exportar modelo de bloco ou item",
	"action.export_blockmodel.desc": "Exportar um modelo de bloco ou item do Minecraft Java Edition",
	"action.export_optifine_part": "Exportar modelo OptiFine",
	"action.export_optifine_part.desc": "Exportar um único modelo de parte de entidade para o OptiFine",
	"action.export_optifine_full": "Exportar OptiFine JEM",
	"action.export_optifine_full.desc": "Exportar um modelo de entidade completo do OptiFine",
	"action.export_obj": "Exportar modelo OBJ",
	"action.export_obj.desc": "Exportar um modelo Wavefront OBJ para renderização",
	"action.settings_window": "Configurações...",
	"action.settings_window.desc": "Abrir a janela de configurações do Blockbench.",
	"action.plugins_window": "Extensões...",
	"action.plugins_window.desc": "Abrir a janela da loja de extensões",
	"action.reset_layout": "Redefinir aparência",
	"action.reset_layout.desc": "Redefinir a aparência ao padrão do Blockbench",
	"action.load_plugin": "Carregar extensão de um arquivo",
	"action.load_plugin.desc": "Carregar uma extensão importando o arquivo de origem.",
	"action.reload_plugins": "Recarregar extensões",
	"action.reload_plugins.desc": "Recarregar todas as extensões de desenvolvimento.",
	"action.undo": "Desfazer",
	"action.undo.desc": "Desfaz a última alteração",
	"action.redo": "Refazer",
	"action.redo.desc": "Reverte a última ação desfeita",
	"action.copy": "Copiar",
	"action.copy.desc": "Copiar a seleção, face ou configurações de exibição atuais",
	"action.paste": "Colar",
	"action.paste.desc": "Colar a seleção, face ou configurações de exibição atuais",
	"action.cut": "Recortar",
	"action.cut.desc": "Recortar a seleção, face ou configurações de exibição atuais",
	"action.add_cube": "Adicionar cubo",
	"action.add_cube.desc": "Adiciona um novo cubo",
	"action.add_group": "Adicionar grupo",
	"action.add_group.desc": "Adiciona um novo grupo ou osso",
	"action.outliner_toggle": "Mostrar mais opções",
	"action.outliner_toggle.desc": "Mostra opções adicionais no organizador",
	"action.duplicate": "Duplicar",
	"action.delete": "Excluir",
	"action.sort_outliner": "Ordenar",
	"action.sort_outliner.desc": "Ordenar os elementos em ordem alfabética",
	"action.select_window": "Selecionar...",
	"action.select_window.desc": "Procurar e selecionar cubos com base em suas propriedades",
	"action.invert_selection": "Inverter seleção",
	"action.invert_selection.desc": "Inverter a seleção atual de cubos",
	"action.select_all": "Selecionar tudo",
	"action.collapse_groups": "Recolher grupos",
	"action.collapse_groups.desc": "Recolher todos os grupos",
	"action.scale": "Redimensionar...",
	"action.scale.desc": "Redimensionar os cubos selecionados",
	"action.toggle_visibility": "Alternar visibilidade",
	"action.toggle_visibility.desc": "Alternar a visibilidade dos cubos selecionados",
	"action.toggle_export": "Alternar exportação",
	"action.toggle_export.desc": "Alternar as configurações de exportação dos cubos selecionados",
	"action.toggle_autouv": "Alternar Auto UV",
	"action.toggle_autouv.desc": "Alternar as configurações de auto UV dos cubos selecionados",
	"action.toggle_shade": "Alternar sombreamento",
	"action.toggle_shade.desc": "Alternar o sombreamento dos cubos selecionados",
	"action.rename": "Renomear",
	"action.rename.desc": "Mudar o nome dos cubos selecionados",
	"action.add_display_preset": "Nova predefinição",
	"action.add_display_preset.desc": "Adicionar uma nova predefinição de configuração de exibição",
	"action.fullscreen": "Tela Cheia",
	"action.fullscreen.desc": "Alterna para o modo de Tela Cheia",
	"action.zoom_in": "Mais Zoom",
	"action.zoom_in.desc": "Aumentar o zoom para ampliar a interface",
	"action.zoom_out": "Reduzir o Zoom",
	"action.zoom_out.desc": "Reduzir o Zoom para reduzir a interface",
	"action.zoom_reset": "Redefinir Zoom",
	"action.zoom_reset.desc": "Redefinir o Zoom para o padrão 100%",
	"action.reset_interface": "Redefinir Interface",
	"action.reset_interface.desc": "Redefinir o tamanho e as posições da interface",
	"action.screenshot_model": "Fotografar Modelo",
	"action.screenshot_model.desc": "Fazer uma captura de tela recortada do modelo do ângulo atual",
	"action.screenshot_app": "Fotografar Aplicativo",
	"action.screenshot_app.desc": "Tirar uma captura de tela de toda a aplicação",
	"action.import_texture": "Importar Textura",
	"action.import_texture.desc": "Importar uma ou mais texturas do seu arquivo do sistema",
	"action.create_texture": "Criar Textura",
	"action.create_texture.desc": "Criar uma textura ou padrão de textura em branco",
	"action.save_textures": "Salvar Texturas",
	"action.save_textures.desc": "Salva as texturas não salvas",
	"action.animated_textures": "Iniciar Texturas Animadas",
	"action.animated_textures.desc": "Iniciar e pausar a pré visualização das texturas animadas",
	"action.origin_to_geometry": "Origem para Geometria",
	"action.origin_to_geometry.desc": "Definir a origem para o centro da geometria",
	"action.bone_reset_toggle": "Redefinir Osso",
	"action.bone_reset_toggle.desc": "Impedir que o osso exiba cubos do modelo pai",
	"action.reload": "Recarregar o Blockbench",
	"action.reload.desc": "Recarrega o Blockbench. Isso removerá todos os progressos não salvos",
	"menu.file": "Arquivo",
	"menu.edit": "Editar",
	"menu.transform": "Transformar",
	"menu.display": "Exibição",
	"menu.view": "Visualizar",
	"menu.file.new": "Novo",
	"menu.file.recent": "Recente",
	"menu.file.import": "Importar",
	"menu.file.export": "Exportar",
	"menu.transform.rotate": "Girar",
	"menu.transform.flip": "Inverter",
	"menu.transform.center": "Centralizar",
	"menu.transform.properties": "Propriedades",
	"menu.display.preset": "Aplicar Predefinição",
	"menu.display.preset_all": "Aplicar Predefinição em Todo Lugar",
	"menu.display.remove_preset": "Remover Predefinição",
	"menu.view.zoom": "Zoom",
	"menu.view.background": "Plano de Fundo",
	"menu.view.screenshot": "Captura de Tela",
	"menu.cube.color": "Cor do Marcador",
	"menu.cube.texture": "Textura",
	"menu.cube.texture.transparent": "Transparente",
	"menu.cube.texture.blank": "Em Branco",
	"menu.group.sort": "Ordenar",
	"menu.texture.face": "Aplicar à Face",
	"menu.texture.file": "Arquivo",
	"menu.texture.refresh": "Atualizar",
	"menu.texture.change": "Mudar Arquivo",
	"menu.texture.folder": "Abrir na Pasta",
	"menu.texture.edit": "Editar",
	"menu.texture.export": "Salvar Como",
	"menu.texture.save": "Salvar",
	"menu.texture.properties": "Propriedades...",
	"menu.preview.background": "Plano de Fundo",
	"menu.preview.background.load": "Carregar",
	"menu.preview.background.position": "Posição",
	"menu.preview.background.lock": "Travar À Câmera",
	"menu.preview.screenshot": "Captura de Tela",
	"menu.preview.perspective": "Perspectiva",
	"menu.preview.perspective.normal": "Normal",
	"menu.preview.quadview": "Visão Quad",
	"menu.preview.stop_drag": "Pare o Posicionamento do Plano de Fundo",
	"menu.uv.mapping.rotation": "Rotação",
	"menu.uv.texture": "Textura",
	"cube.color.light_blue": "Azul claro",
	"cube.color.yellow": "Amarelo",
	"cube.color.orange": "Laranja",
	"cube.color.red": "Vermelho",
	"cube.color.purple": "Roxo",
	"cube.color.blue": "Azul",
	"cube.color.green": "Verde",
	"cube.color.lime": "Lime",
	"switches.visibility": "Visibilidade",
	"switches.export": "Exportar",
	"switches.autouv": "Auto UV",
	"panel.uv": "UV",
	"panel.display": "Padrão",
	"panel.textures": "Texturas",
	"panel.outliner": "Organizador",
	"uv_editor.title": "Editor de UV",
	"uv_editor.all_faces": "Todas",
	"uv_editor.no_faces": "Nenhum",
	"face.north": "Norte",
	"face.south": "Sul",
	"face.west": "Oeste",
	"face.east": "Leste",
	"face.up": "Cima",
	"face.down": "Baixo",
	"direction.north": "Norte",
	"direction.south": "Sul",
	"direction.west": "Oeste",
	"direction.east": "Leste",
	"direction.top": "Topo",
	"direction.bottom": "Baixo",
	"display.slot.third_right": "Direita da Terceira Pessoa",
	"display.slot.third_left": "Esquerda da Terceira Pessoa",
	"display.slot.first_right": "Direita da Primeira Pessoa",
	"display.slot.first_left": "Esquerda da Primeira Pessoa",
	"display.slot.head": "Cabeça",
	"display.slot.ground": "Ground",
	"display.slot.frame": "Quadro",
	"display.slot.gui": "Interface",
	"display.rotation": "Rotação",
	"display.translation": "Translação",
	"display.scale": "Redimensionar",
	"display.slot": "Slot",
	"display.reference": "Modelo de Referência",
	"display.reference.player": "Jogador",
	"display.reference.zombie": "Zumbi",
	"display.reference.armor_stand": "Suporte de Armadura",
	"display.reference.baby_zombie": "Zumbi Bebê",
	"display.reference.armor_stand_small": "Suporte de Armadura Pequeno",
	"display.reference.monitor": "Normal",
	"display.reference.bow": "Arco",
	"display.reference.block": "Bloco",
	"display.reference.frame": "Moldura",
	"display.reference.inventory_nine": "3x3",
	"display.reference.inventory_full": "Inventário",
	"display.reference.hud": "HUD",
	"display.preset.blank_name": "Por favor insira um nome",
	"display.preset.item": "Item Padrão",
	"display.preset.block": "Bloco Padrão",
	"display.preset.handheld": "Arma Padrão",
	"display.preset.rod": "Vara Padrão",
	"dialog.continue": "Continuar",
	"message.square_textures": "Texturas têm que ser quadradas",
	"message.unsaved_texture.title": "Textura Não Salva",
	"message.unsaved_texture.message": "Todas as alterações não salvas serão perdidas. Deseja continuar?",
	"action.vertex_snap_mode.move": "Mover",
	"action.vertex_snap_mode.scale": "Redimensionar",
	"action.open_model_folder": "Abrir Pasta de Modelos",
	"action.open_model_folder.desc": "Abre a pasta onde o modelo está contido",
	"action.change_textures_folder": "Mudar Local da Textura",
	"action.change_textures_folder.desc": "Alterar a pasta em que todas as texturas são salvas",
	"menu.texture.particle": "Usar para Partículas",
	"message.update_notification.title": "Não foi possível instalar a atualização",
	"message.update_notification.message": "Uma nova versão do Blockbench está disponível. Por favor ative a opção Atualizações Automáticas nas configurações para atualizar!",
	"message.untextured": "Esta superfície não tem uma textura",
	"dialog.toolbar_edit.title": "Customizar Barra de Ferramentas",
	"keybindings.reset": "Redefinir",
	"keybindings.clear": "Vazio",
	"action.cube_counter": "Contador de Cubos",
	"action.uv_rotation": "Rotação UV",
	"action.uv_rotation.desc": "Rotação da face UV",
	"action.uv_grid": "Grade UV",
	"action.uv_grid.desc": "A resolução da grade na qual o seletor UV se encaixa",
	"action.uv_grid.auto": "Auto",
	"action.uv_maximize": "Maximizar UV",
	"action.uv_maximize.desc": "Define o UV desta face para a textura total",
	"action.uv_auto": "Auto UV",
	"action.uv_auto.desc": "Define o tamanho de UV dessa face para o tamanho real da face",
	"action.uv_rel_auto": "Auto UV Relativo",
	"action.uv_rel_auto.desc": "Define o UV dessa face para a posição e tamanho da face real",
	"action.uv_mirror_x": "Espelhar UV X",
	"action.uv_mirror_x.desc": "Espelha o UV da face no eixo X",
	"action.uv_mirror_y": "Espelhar UV Y",
	"action.uv_mirror_y.desc": "Espelha  o UV da face no eixo Y",
	"action.uv_transparent": "Remover face",
	"action.uv_transparent.desc": "Remove a face atual",
	"action.uv_reset": "Redefinir Face",
	"action.uv_reset.desc": "Redefine a Face atual",
	"action.cullface": "Face Coberta",
	"action.cullface.desc": "Desativa a renderização para essa face se o lado selecionado do modelo for coberto",
	"action.auto_cullface": "Auto Cobrir Face",
	"action.auto_cullface.desc": "Define a cobertura de face desta para si",
	"action.face_tint": "Tom",
	"action.face_tint.desc": "Ativa a opção de tom para a face atual",
	"menu.toolbar.edit": "Customizar",
	"menu.toolbar.reset": "Redefinir",
	"uv_editor.rotated": "Girado",
	"uv_editor.auto_cull": "Cobrir Própria Face",
	"uv_editor.copied": "Face Copiada",
	"uv_editor.pasted": "Face Colada",
	"uv_editor.copied_x": "Copiadas %0 Faces",
	"uv_editor.reset": "Redefinir Face",
	"uv_editor.maximized": "Maximizado",
	"uv_editor.autouv": "Tamanho Automático",
	"uv_editor.mirrored": "Espelhado",
	"uv_editor.to_all": "Aplicado para todas as Faces",
	"uv_editor.transparent": "Feito Transparente",
	"uv_editor.cullface_on": "Face Coberta Ligada",
	"uv_editor.cullface_off": "Face Coberta Desligada",
	"uv_editor.tint_on": "Tom Ligado",
	"uv_editor.tint_off": "Tom Desligado",
	"action.uv_apply_all": "Aplicar para todas as Faces",
	"action.uv_apply_all.desc": "Aplica as configurações na face atual e para todas as faces",
	"message.image_editor_missing.title": "Editor de Imagem Padrão",
	"message.image_editor_missing.message": "Selecione o arquivo executável do seu editor de imagem",
	"message.image_editor_missing.detail": "O Blockbench não conseguiu encontrar um editor de imagens no seu computador. Selecione o arquivo executável do seu editor de imagens preferido.",
	"action.update_autouv": "Atualizar Auto UV",
	"action.update_autouv.desc": "Atualiza o auto UV mapeando os cubos selecionados",
	"category.uv": "UV",
	"status_bar.saved": "O Modelo foi salvo",
	"status_bar.unsaved": "Existem alterações não salvas",
	"action.move_up": "Mover para Cima",
	"action.move_up.desc": "Mover os cubos selecionados para cima em relação ao ângulo atual da câmera",
	"action.move_down": "Mover para Baixo",
	"action.move_down.desc": "Mover os cubos selecionados para baixo em relação ao ângulo atual da câmera",
	"action.move_left": "Mover para Esquerda",
	"action.move_left.desc": "Mover os cubos selecionados para a esquerda em relação ao ângulo atual da câmera",
	"action.move_right": "Mover para Direita",
	"action.move_right.desc": "Mover os cubos selecionados para a direita em relação ao ângulo atual da câmera",
	"action.move_forth": "Mover para Frente",
	"action.move_forth.desc": "Mover os cubos selecionados para a frente em relação ao ângulo atual da câmera",
	"action.move_back": "Mover para Trás",
	"action.move_back.desc": "Mover os cubos selecionados para a trás em relação ao ângulo atual da câmera",
	"layout.color.wireframe": "Visão de Arames",
	"layout.color.wireframe.desc": "Linhas de visão de arames",
	"action.add_animation": "Adicionar Animação",
	"action.add_animation.desc": "Criar uma animação em branco",
	"action.load_animation_file": "Importar Animações",
	"action.load_animation_file.desc": "Importar um arquivo de animação",
	"action.play_animation": "Iniciar Animação",
	"action.play_animation.desc": "Pré Visualização de animação",
	"action.slider_keyframe_time": "Tempo",
	"action.slider_keyframe_time.desc": "Alterar o tempo dos quadros selecionados",
	"timeline.rotation": "Rotação",
	"timeline.position": "Posição",
	"timeline.scale": "Redimensionar",
	"menu.keyframe.quaternion": "Quaternião",
	"panel.animations": "Animações",
	"panel.keyframe": "Quadro",
	"panel.keyframe.type": "Quadro (%0)",
	"generic.delete": "Apagar",
	"generic.rename": "Renomear",
	"message.no_animation_selected": "Você tem que selecionar uma animação para fazer isso",
	"message.no_bone_selected": "Você tem que selecionar um osso para fazer isso",
	"message.duplicate_groups.title": "Nome do Osso Duplicado",
	"message.duplicate_groups.message": "O nome deste osso existe em vários ossos. Isso pode causar problemas.",
	"action.delete_keyframes": "Apagar Quadros",
	"action.delete_keyframes.desc": "Apagar todos os quadros selecionados",
	"menu.animation": "Animação",
	"menu.animation.loop": "Modo Loop",
	"menu.animation.override": "Sobrescrever",
	"menu.animation.anim_time_update": "Atualizar tempo de animação",
	"message.display_skin_model.title": "Modelo da Skin",
	"message.display_skin_model.message": "Selecione o tipo de modelo da sua skin",
	"message.display_skin_model.classic": "Clássico",
	"message.display_skin_model.slim": "Magro",
	"message.bone_material": "Mudar o material do osso",
	"action.slider_animation_length": "Duração da animação",
	"action.slider_animation_length.desc": "Muda a duração da animação selecionada",
	"panel.variable_placeholders": "Preenchedores de Espaço de Variáveis",
	"status_bar.vertex_distance": "Distância: %0",
	"dialog.create_gif.title": "Gravar GIF",
	"dialog.create_gif.length": "Duração",
	"dialog.create_gif.fps": "FPS",
	"dialog.create_gif.play": "Iniciar Animação",
	"category.animation": "Animação",
	"action.record_model_gif": "Gravar GIF",
	"action.record_model_gif.desc": "Grava um GIF animado do modelo do ângulo atual",
	"display.mirror": "Reflexar",
	"data.separator": "Separador",
	"menu.preview.background.set_position": "Definir Posição",
	"dialog.toolbar_edit.hidden": "Escondido",
	"action.export_class_entity": "Exportar Entidade Java",
	"action.export_class_entity.desc": "Exportar o modelo da entidade como uma classe Java",
	"settings.seethrough_outline": "Contornos Raio X",
	"settings.seethrough_outline.desc": "Mostrar contornos através de objetos",
	"mode.edit": "Editar",
	"mode.paint": "Pintar",
	"mode.display": "Exibir",
	"mode.animate": "Animar",
	"status_bar.recording_gif": "Gravando GIF",
	"status_bar.processing_gif": "Processando GIF",
	"settings.backup_retain": "Prazo de Armazenamento de Backups",
	"settings.backup_retain.desc": "Definir por quanto tempo o Blockbench mantém backups antigos em dias",
	"action.rotate_tool": "Girar",
	"action.rotate_tool.desc": "Ferramenta para selecionar e girar elementos",
	"action.fill_tool": "Lata de Tinta",
	"action.fill_tool.desc": "Lata de tinta para preencher faces inteiras com uma cor",
	"action.eraser": "Borracha",
	"action.eraser.desc": "Ferramenta borracha para substituir cores em uma textura com transparência",
	"action.color_picker": "Seletor de Cores",
	"action.color_picker.desc": "Ferramenta para escolher a cor dos pixels na sua textura",
	"switches.mirror": "Reflexar UV",
	"language_name": "Português",
	"message.plugin_reload": "Recarregados %0 plugins locais",
	"settings.brightness": "Brilho",
	"settings.brightness.desc": "Brilho da pré visualização. O brilho padrão é 50",
	"menu.preview.perspective.reset": "Redefinir Câmera",
	"action.fill_mode": "Modo de Preenchimento",
	"action.fill_mode.face": "Face",
	"action.fill_mode.color": "Cores",
	"action.toggle_mirror_uv": "Espelhar UV",
	"action.toggle_mirror_uv.desc": "Alternar a inverção do UV no eixo X dos cubos selecionados",
	"menu.texture.blank": "Aplicar a Faces Não Texturizadas",
	"dialog.scale.select_overflow": "Selecionar Estouro",
	"action.action_control": "Controle de Ação",
	"action.action_control.desc": "Pesquise e execute qualquer ação disponível",
	"keybindings.recording": "Gravando de Atalho do Teclado",
	"keybindings.press": "Pressione uma tecla ou combinação de teclas ou clique em qualquer lugar da tela para gravar sua combinação de teclas.",
	"action.pivot_tool": "Ferramenta Pivô",
	"action.pivot_tool.desc": "Ferramenta para alterar o ponto de articulação de cubos e ossos",
	"action.slider_animation_speed": "Velocidade de reprodução",
	"action.slider_animation_speed.desc": "Velocidade de reprodução da linha do tempo em porcentagem",
	"action.previous_keyframe": "Quadro anterior",
	"action.previous_keyframe.desc": "Pular para o quadro anterior",
	"action.next_keyframe": "Próximo quadro",
	"action.next_keyframe.desc": "Pular para o próximo quadro",
	"message.outdated_client.title": "Cliente desatualizado",
	"message.outdated_client.message": "Por favor atualize o Blockbench para a última versão para fazer isso.",
	"action.export_asset_archive": "Baixar Pacote",
	"action.export_asset_archive.desc": "Baixar um pacote contendo o modelo e todas as texturas",
	"action.upload_sketchfab": "Fazer Upload no Sketchfab",
	"message.sketchfab.name_or_token": "Por favor insira seu token e nome do Sketchfab",
	"dialog.sketchfab_uploader.title": "Upload do Modelo no Sketchfab",
	"dialog.sketchfab_uploader.token": "Token de API",
	"dialog.sketchfab_uploader.about_token": "O token é usado para conectar o Blockbench à sua conta do Sketchfab. Você pode encontrá-lo em %0",
	"dialog.sketchfab_uploader.name": "Nome do Modelo",
	"dialog.sketchfab_uploader.description": "Descrição",
	"dialog.sketchfab_uploader.tags": "Tags",
	"settings.sketchfab_token": "Token do Sketchfab",
	"settings.sketchfab_token.desc": "Token para autorizar o Blockbench a fazer upload para sua conta do Sketchfab",
	"panel.color": "Cor",
	"data.origin": "Origem",
	"message.sketchfab.success": "Upload do modelo realizado com sucesso",
	"message.sketchfab.error": "Falha ao fazer upload do modelo ao Sketchfab",
	"settings.outliner_colors": "Cores do organizador",
	"settings.outliner_colors.desc": "Mostrar cores de elementos e grupos no organizador",
	"action.upload_sketchfab.desc": "Fazer upload do seu modelo no Sketchfab",
	"action.element_colors": "Cores de Cubos",
	"action.element_colors.desc": "Mostrar cores de cubos no organizador",
	"texture.error.file": "Arquivo não encontrado",
	"texture.error.parent": "Arquivo de textura dado pelo modelo pai",
	"message.recover_backup.title": "Recuperar Modelo",
	"message.recover_backup.message": "Blockbench foi fechado sem salvar. Deseja recuperar o modelo?",
	"message.invalid_session.title": "Token de Sessão Inválido",
	"message.invalid_session.message": "A sessão a qual você está tentando entrar expirou ou o token fornecido é inválido.",
	"dialog.create_texture.power": "Tamanho em Potência-de-base-2",
	"dialog.create_gif.turn": "Velocidade do tocador",
	"action.edit_session": "Sessão de Edição...",
	"action.edit_session.desc": "Conectar a uma sessão de edição para colaborar com outros usuários",
	"action.reset_keyframe": "Redefinir Quadro",
	"action.reset_keyframe.desc": "Redefinir todos os valores dos quadros selecionados",
	"dialog.edit_session.title": "Sessão de Edição",
	"edit_session.username": "Nome de usuário",
	"edit_session.token": "Token",
	"edit_session.about": "Sessões de Edição podem ser usadas para colaborar em modelos através da Internet. Crie uma sessão, copie o token e envie-o para amigos, que podem usá-lo para entrar.",
	"edit_session.join": "Entrar na Sessão",
	"edit_session.create": "Criar Sessão",
	"edit_session.quit": "Sair da Sessão",
	"edit_session.joined": "%0 entrou na sessão",
	"edit_session.left": "%0 saiu da sessão",
	"edit_session.quit_session": "Saiu da sessão atual",
	"edit_session.status": "Status",
	"edit_session.hosting": "Hospedando",
	"edit_session.connected": "Conectado a uma sessão",
	"dialog.sketchfab_uploader.private": "Privado (Pro)",
	"dialog.sketchfab_uploader.password": "Senha (Pro)",
	"action.uv_select_all": "Selecionar Tudo",
	"action.uv_select_all.desc": "Seleciona todas as faces no diálogo de UV",
	"panel.chat": "Bate-papo",
	"edit_session.welcome": "Bem vindo à essa sessão de %0",
	"dialog.yes": "Sim",
	"dialog.no": "Não",
	"generic.remove": "Remover",
	"generic.download": "Download",
	"generic.search": "Pesquisa",
	"dates.today": "Hoje",
	"dates.yesterday": "Ontem",
	"dates.this_week": "Esta semana",
	"dates.weeks_ago": "%0 semanas atrás",
	"mode.start.new": "Novo",
	"mode.start.recent": "Recente",
	"format.free": "Modelo Genérico",
	"format.free.desc": "Modelo sem restrições. Para motores de jogos, renderização, etc.",
	"format.java_block": "Bloco/Item Java",
	"format.java_block.desc": "Modelo de Bloco ou Item para a Edição Java.",
	"format.bedrock": "Modelo Bedrock",
	"format.bedrock.desc": "Modelo para Minecraft Bedrock Edition",
	"format.bedrock_old": "Modelo de Legado Bedrock Edition",
	"format.bedrock_old.desc": "Modelo de entidade para Minecraft Bedrock Edition Pre-1.12",
	"format.modded_entity": "Entidade Modificada",
	"format.modded_entity.desc": "Modelos de entidade para mods. Pode ser exportado como arquivos .java class.",
	"format.optifine_entity": "Entidade OptiFine",
	"format.optifine_entity.desc": "Modelo customizado de entidade para OptiFine.",
	"keys.mouse": "Botão do Mouse %0",
	"message.cleared_blank_faces.title": "Faces em branco",
	"message.cleared_blank_faces.message": "O Blockbench encontrou %0 cubos sem nenhuma textura. Deseja remover esses elementos?",
	"message.wireframe.enabled": "Visualização de estrutura de arame ativada",
	"message.wireframe.disabled": "Visualização de estrutura de arame desativada",
	"dialog.convert_project.title": "Converter Projeto",
	"dialog.create_texture.double_use": "Manter ocupação de textura múltipla",
	"dialog.model_stats.title": "Status do Modelo",
	"dialog.model_stats.cubes": "Cubos",
	"dialog.model_stats.locators": "Localizadores",
	"dialog.model_stats.groups": "Grupos",
	"dialog.model_stats.vertices": "Vértices",
	"dialog.model_stats.faces": "Faces",
	"settings.username": "Nome de Usuário",
	"settings.username.desc": "Nome de usuário para sessões de edição.",
	"settings.painting_grid": "Grade de pintura",
	"settings.painting_grid.desc": "Mostrar grade em cubos texturizados no modo de pintura.",
	"action.convert_project": "Converter Projeto",
	"action.convert_project.desc": "Converte o projeto atual em um projeto para outro formato de modelo.",
	"action.close_project": "Fechar Projeto",
	"action.close_project.desc": "Fecha o projeto aberto atualmente.",
	"action.export_bedrock": "Exportar Geometria Bedrock",
	"action.export_bedrock.desc": "Exporte o modelo como um arquivo de Geometria Bedrock Edition.",
	"action.save_project": "Salvar o projeto",
	"action.save_project.desc": "Salva o modelo atual como um arquivo de projeto.",
	"action.save_project_as": "Salvar Projeto Como...",
	"action.save_project_as.desc": "Salva o modelo atual como um arquivo de projeto em um novo local.",
	"action.export_over": "Substituir Modelo",
	"action.export_over.desc": "Salva o modelo, texturas e animações substituindo os arquivos.",
	"action.add_locator": "Adicionar localizador",
	"action.add_locator.desc": "Adiciona um novo localizador para controlar posições de partículas, cordas etc.",
	"action.uv_turn_mapping": "Mapeamento de Giros",
	"action.uv_turn_mapping.desc": "Gire o mapeamento UV em cerca de 90 graus.",
	"action.remove_blank_faces": "Remover faces em branco",
	"action.remove_blank_faces.desc": "Exclui todas as faces não texturizadas da seleção.",
	"web.download_app": "Baixar aplicativo",
	"uv_editor.turned": "Mapeamento ativado",
	"display.reference.crossbow": "Besta",
	"dialog.settings.search_results": "Procurar Resultados",
	"settings.animation_snap": "Snap de animação",
	"settings.animation_snap.desc": "Intervalo de snap para quadros na linha do tempo da animação em etapas por segundo.",
	"action.import_optifine_part": "Importar parte OptiFine",
	"action.import_optifine_part.desc": "Importar uma parte de modelo de entidade para o OptiFine.",
	"data.locator": "Localizador",
	"mode.start.no_recents": "Nenhum modelo aberto recentemente",
	"panel.element": "Elemento",
	"panel.element.position": "Posição",
	"panel.element.size": "Tamanho",
	"panel.element.origin": "Ponto de Pivô",
	"panel.element.rotation": "Rotação",
	"message.canvas_limit_error.title": "Erro de limite de tela",
	"message.canvas_limit_error.message": "A ação não pôde ser executada corretamente porque o formato limita a tela a 48 unidades. Mude o ponto de articulação para evitar isso.",
	"data.effect": "Efeito",
	"generic.name": "Nome",
	"settings.recent_projects": "Limite de modelo recente",
	"settings.recent_projects.desc": "Número máximo de modelos recentes a serem lembrados.",
	"settings.volume": "Volume",
	"settings.volume.desc": "Controle de volume para efeitos sonoros em animações.",
	"action.clear_timeline": "Limpar Linha do Tempo",
	"action.clear_timeline.desc": "Limpar todos os ossos não selecionados da linha do tempo.",
	"action.select_effect_animator": "Efeitos animados",
	"action.select_effect_animator.desc": "Abre a linha do tempo para adicionar sons e efeitos de partículas.",
	"action.timeline_focus": "Filtrar canais",
	"action.timeline_focus.desc": "Selecione os canais de animação para exibir na linha do tempo.",
	"timeline.particle": "Partícula",
	"timeline.sound": "Som",
	"timeline.effects": "Efeitos",
	"data.format": "Formato",
	"format.optifine_part": "Parte de OptiFine",
	"format.optifine_part.desc": "Parte JPM para modelos de entidade OptiFine.",
	"action.reverse_keyframes": "Quadros reversos",
	"action.reverse_keyframes.desc": "Inverter a ordem dos quadros selecionados.",
	"generic.help": "Ajuda",
	"message.removed_faces": "%0 faces removidas",
	"dialog.sketchfab_uploader.draft": "Esboço",
	"action.slider_pos": "Mover %0",
	"action.slider_pos.desc": "Mover cubos no eixo %0",
	"action.slider_size": "Tamanho %0",
	"action.slider_size.desc": "Redimensionar cubos no eixo %0.",
	"action.slider_rotation": "Rodar %0",
	"action.slider_rotation.desc": "Girar cubos no eixo %0",
	"action.slider_origin": "Pivô %0",
	"action.slider_origin.desc": "Mover o pivô no eixo %0",
	"action.rotate_cw": "Girar %0 +90",
	"action.rotate_cw.desc": "Gira os cubos selecionados 90 ° no eixo %0",
	"action.rotate_ccw": "Rodar %0 -90",
	"action.rotate_ccw.desc": "Gira os cubos selecionados  -90° no eixo %0",
	"action.flip": "Virar %0",
	"action.flip.desc": "Vire os cubos selecionados no eixo %0",
	"action.center": "Centro %0",
	"action.center.desc": "Centralize os cubos selecionados no eixo %0",
	"action.bring_up_all_animations": "Trazer todas as animações",
	"panel.bone": "Osso",
	"data.color": "Cor",
	"generic.export": "Exportar",
	"generic.none": "Nenhum",
	"status_bar.recording": "Linha do Tempo de gravação",
	"message.add_to_palette": "Adicionado à paleta",
	"message.size_modifiers": "Mantenha pressionada a tecla Ctrl ou Shift para transformar em incrementos menores.",
	"message.timelapse_start": "Timelapse iniciado",
	"message.timelapse_stop": "Timelapse parado",
	"message.import_palette.replace_palette": "Substituir paleta antiga",
	"message.import_palette.threshold": "Limiar de mesclagem",
	"dialog.timelapse.interval": "Intervalo (Segundos)",
	"dialog.timelapse.source": "Fonte",
	"dialog.timelapse.source.interface": "Interface",
	"dialog.timelapse.source.locked": "Ângulo bloqueado",
	"dialog.timelapse.destination": "Pasta de destino",
	"layout.color.checkerboard": "Tabuleiro Xadrez",
	"layout.color.checkerboard.desc": "Fundo de tela e editor UV",
	"layout.font.code": "Código da fonte",
	"layout.css": "CSS customizado",
	"settings.category.paint": "Pintar",
	"settings.deactivate_size_limit": "Desativar limite de tamanho",
	"settings.deactivate_size_limit.desc": "Desative o limite de tamanho para formatos de modelo específicos. AVISO: Isso pode causar modelos inválidos.",
	"settings.brush_opacity_modifier": "Modificador de opacidade do pincel",
	"settings.brush_opacity_modifier.desc": "Modifique a opacidade do pincel ao usar uma caneta",
	"settings.brush_size_modifier": "Modificador de tamanho de pincel",
	"settings.brush_size_modifier.desc": "Modifique o tamanho do pincel ao usar uma caneta",
	"settings.brush_modifier.pressure": "Pressão",
	"settings.brush_modifier.tilt": "Inclinar",
	"category.color": "Cor",
	"action.import_theme": "Importar Tema",
	"action.export_theme": "Exportar Tema",
	"action.export_theme.desc": "Crie um arquivo de tema com base nas configurações atuais",
	"action.slider_color_h": "Matiz",
	"action.slider_color_s": "Saturação",
	"action.slider_color_v": "Value",
	"action.add_to_palette": "Adicionar a Paleta",
	"action.add_to_palette.desc": "Adicione a cor selecionada à paleta de cores",
	"action.import_palette": "Importar Paleta",
	"action.import_palette.desc": "Importar um ficheiro .bbpalette",
	"action.export_palette": "Exportar Paleta",
	"action.export_palette.desc": "Exportar a paleta com um arquivo .bbpalette",
	"action.generate_palette": "Gerar Paleta",
	"action.generate_palette.desc": "Gerar paleta a partir de uma textura",
	"action.sort_palette": "Classificar Paleta",
	"action.sort_palette.desc": "Classifique todas as cores da paleta por cor e brilho",
	"action.timelapse": "Timelapse...",
	"action.timelapse.desc": "Grave um timelapse do seu progresso de modelagem",
	"action.add_keyframe": "Adicionar quadro-chave",
	"action.add_keyframe.desc": "Adicione automaticamente um quadro-chave. Pressione shift para forçar os valores padrão",
	"action.bring_up_all_animations.desc": "Traz todos os animadores modificados para a linha do tempo",
	"timeline.timeline": "Instruções",
	"menu.palette.load.default": "Padrão",
	"generic.import": "Importar",
	"settings.brush_modifier.none": "Nenhum",
	"action.export_entity": "Exportar Entidade Bedrock",
	"action.export_entity.desc": "Inclua o modelo atual como uma entidade em um arquivo mobs.json",
	"settings.highlight_cubes": "Destacar cubos",
	"settings.highlight_cubes.desc": "Realce cubos quando você passa o mouse sobre eles ou os seleciona",
	"action.add_marker": "Definir marcador",
	"action.add_marker.desc": "Definir um marcador da linha do tempo",
	"timeline.pre_effect_script": "Roteiro",
	"format.skin": "Skin do Minecraft",
	"format.skin.desc": "Edite skins de jogadores e entidades",
	"message.sketchfab.setup_guide": "Precisa aprender a como configurar seus modelos no Sketchfab? Leia %0",
	"dialog.skin.title": "Criar Skin do Minecraft",
	"dialog.skin.model": "Modelo",
	"action.toggle_skin_layer": "Alterar camada da Skin",
	"action.toggle_skin_layer.desc": "Alterar a camada do chapéu e da roupa do modelo da skin",
	"action.gui_light": "Luz da GUI",
	"action.gui_light.desc": "Selecione a maneira como o item é iluminado no inventário",
	"action.gui_light.side": "Luz Lateral",
	"action.gui_light.front": "Luz Frontal",
	"action.move_keyframe_back": "Mover quadros para trás",
	"action.move_keyframe_forth": "Mover quadros adiante",
	"menu.help": "Ajuda\n",
	"menu.help.discord": "Servidor Discord",
	"menu.help.report_issue": "Reportar um erro",
	"menu.help.plugin_documentation": "Documentação Plugin API",
	"menu.help.search_action": "Buscar e rodar uma ação",
	"menu.help.donate": "Doar",
	"menu.help.about": "Sobre...",
	"menu.preview.background.clipboard": "Carregar da área de transferência",
	"dialog.ignore": "Ignorar",
	"generic.unset": "Desativar",
	"message.invalid_builtin_parent.title": "Pai incorporado interno inválido",
	"message.invalid_builtin_parent.message": "O link para o modelo pai inválido '%0' foi removido para exportar um modelo válido.",
	"dialog.resize_texture.fill": "Preencher com",
	"dialog.resize_texture.fill.transparent": "Transparente",
	"dialog.resize_texture.fill.color": "Cor",
	"dialog.resize_texture.fill.repeat": "Repetir",
	"dialog.scale.element_pivot": "Elemento do Pivô",
	"dialog.scale.selection_center": "Centro de Seleção",
	"dialog.create_gif.length_mode": "Modo Comprimento",
	"dialog.create_gif.length_mode.seconds": "Segundos",
	"dialog.create_gif.length_mode.frames": "Quadros",
	"dialog.create_gif.length_mode.animation": "Comprimento da Animação",
	"dialog.create_gif.length_mode.turntable": "Rotação de mesa giratória",
	"dialog.save_angle.projection": "Projeção",
	"dialog.save_angle.projection.perspective": "Perspectiva",
	"dialog.save_angle.projection.orthographic": "Ortográfico",
	"dialog.sketchfab_uploader.animations": "Animações",
	"dialog.settings.theme": "Tema",
	"settings.category.interface": "Interface",
	"settings.preview_checkerboard": "Mostrar Tabuleiro Xadrez",
	"settings.preview_checkerboard.desc": "Alterne o plano de fundo do tabuleiro xadrez atrás da visualização",
	"settings.uv_checkerboard": "Editor UV do tabuleiro xadrez",
	"settings.uv_checkerboard.desc": "Alterne o fundo do tabuleiro xadrez atrás do editor UV",
	"category.paint": "Pintar",
	"action.fill_mode.color_connected": "Cores Conectadas",
	"action.draw_shape_type": "Tipo da Forma",
	"action.draw_shape_type.rectangle": "Retângulo",
	"action.draw_shape_type.rectangle_h": "Retângulo(Vazio)",
	"action.draw_shape_type.ellipse": "Elipse",
	"action.draw_shape_type.ellipse_h": "Elipse(Vazio)",
	"action.draw_shape_type.line": "Linha",
	"action.mirror_painting": "Pintura Espelhada",
	"action.mirror_painting.description": "Espelhe seus traços de tinta para o outro lado do modelo",
	"action.lock_alpha": "Travar Canal Alfa",
	"action.lock_alpha.description": "Trave a transparência de todos os pixels",
	"action.draw_shape_tool": "Desenhar Forma",
	"action.draw_shape_tool.desc": "Ferramenta para desenhar formas simples em texturas",
	"action.export_gltf": "Exportar como modelo glTF",
	"action.export_gltf.desc": "Exporta modelo e animações como arquivo glTF para usar em outros aplicativos 3D",
	"action.transform_space": "Transformar Espaço",
	"action.transform_space.desc": "Espaço de transformação padrão para elementos e ossos",
	"action.transform_space.global": "Global",
	"action.transform_space.local": "Local",
	"action.toggle_camera_projection": "Alternar Projeção de Câmera",
	"action.toggle_camera_projection.desc": "Alterna a projeção da câmera entre perspectiva e ortografia",
	"action.load_camera_angle": "Ângulo de Câmera: %0",
	"action.load_camera_angle.desc": "Carregar o ângulo '%0' da câmera ",
	"action.slider_face_tint": "Índice de tonalidade",
	"action.slider_face_tint.desc": "Defina o índice de tonalidade da face atual. -1 significa não definido.",
	"menu.help.quickstart": "Assistente para Iniciantes",
	"menu.help.developer": "Desenvolvedor",
	"menu.help.developer.dev_tools": "Úteis para desenvolvedor",
	"menu.help.developer.reset_storage": "Restauração de fábrica",
	"menu.help.developer.reset_storage.confirm": "Tem certeza de que deseja redefinir as configurações de fábrica do Blockbench? Isso excluirá todas as configurações personalizadas, combinações de teclas e plugins instalados.",
	"menu.help.developer.cache_reload": "Recarga de cache",
	"menu.preview.orthographic": "Ortográfico",
	"menu.preview.save_angle": "Salvar Ângulo",
	"menu.preview.angle": "Ângulos",
	"menu.preview.angle.initial": "Ângulo Inicial",
	"menu.preview.maximize": "Maximizar",
	"uv_editor.copy_selection": "Copiar Seleção",
	"uv_editor.paste_selection": "Colar Seleção",
	"uv_editor.copy_paste_tool.place": "Colocar",
	"uv_editor.copy_paste_tool.mirror_x": "Espelhar X",
	"uv_editor.copy_paste_tool.mirror_y": "Espelhar Y",
	"uv_editor.copy_paste_tool.rotate": "Rodar 90 Graus",
	"dialog.project.modded_entity_version": "Versão de Exporte",
	"dialog.save_angle.position": "Posição da Câmera",
	"dialog.save_angle.target": "Ponto focal",
	"dialog.skin.pose": "Pose",
	"layout.color.frame": "Moldura da janela",
	"layout.color.frame.desc": "Borda e barra de título da janela",
	"settings.large_grid_size": "Tamanho da grade do bloco",
	"settings.large_grid_size.desc": "Tamanho da grade do bloco",
	"action.load_plugin_from_url": "Carregar Plugin de uma URL",
	"action.load_plugin_from_url.desc": "Carregue um plugin de um servidor especificando o URL",
	"action.cube_counter.desc": "Exibe o número atual de cubos e outras estatísticas",
	"action.unlock_everything": "Destravar Tudo",
	"action.unlock_everything.desc": "Desbloqueie todos os grupos e elementos no organizador.",
	"action.load_palette": "Carregar Paleta",
	"action.load_palette.desc": "Carregue uma das predefinições da paleta incorporada",
	"action.toggle_locked": "Alternar trava",
	"action.toggle_locked.desc": "Alternar se os elementos selecionados estão travados",
	"action.apply_display_preset": "Aplicar padrão",
	"action.apply_display_preset.desc": "Aplicar uma predefinição de configuração de exibição padrão ou personalizada",
	"action.apply_display_preset.here": "Aplicar para esse slot",
	"action.apply_display_preset.everywhere": "Aplicar para todos os slots",
	"action.resolve_keyframe_expressions": "Resolver quadro-chave",
	"action.resolve_keyframe_expressions.desc": "Resolve as expressões matemáticas dos quadros selecionados",
	"action.fold_all_animations": "Dobre todos os animadores",
	"menu.palette.load.empty": "Vazio",
	"switches.lock": "Travar",
	"settings.render_sides": "Lados Carregados",
	"settings.render_sides.desc": "Selecione qual lado de uma face é carregado",
	"settings.render_sides.auto": "Auto",
	"settings.render_sides.front": "Fora",
	"settings.render_sides.double": "Dentro e Fora",
	"generic.enable": "Ativar",
	"generic.disable": "Desativar",
	"generic.redacted": "Editado",
	"dialog.select_texture.import_all": "Importar Tudo",
	"dialog.skin.layer_template": "Textura da camada",
	"about.version.up_to_date": "Mais recente",
	"about.version.update_available": "Versão %o está disponivel",
	"settings.category.application": "Aplicações",
	"settings.streamer_mode": "Modo de Streamer",
	"settings.streamer_mode.desc": "Esconder informações sensíveis como modelos recentes",
	"settings.automatic_updates": "Atualizações automáticas",
	"settings.automatic_updates.desc": "Download automático de novas versões e manter BlockBench com a versão mais recente",
	"action.rotation_space": "Espaço de rotação",
	"action.focus_on_selection": "Centralizar o campo de visão na seleção",
	"action.focus_on_selection.desc": "Alinhar a câmera para olhar o centro da seleção atual",
	"action.jump_to_timeline_start": "Pular para o início da animação",
	"action.jump_to_timeline_end": "Pular para o fim da animação",
	"menu.help.updating": "Atualizando (%0%)",
	"menu.help.update_failed": "Falha na atualização",
	"menu.animation.loop.once": "Reproduza uma vez",
	"menu.animation.loop.hold": "Manter no último quadro",
	"menu.animation.loop.loop": "Loop",
	"interface.streamer_mode_on": "Modo Streamer ativado",
	"generic.reset": "Reiniciar",
	"generic.restore": "Restaurar",
	"keys.mousewheel": "Roda do mouse",
	"message.delete_animation.title": "Animação eliminada",
	"message.delete_animation.message": "A animação foi removida do Blockbench. Quer que a animação também seja eliminada do ficheiro onde estava guardada?",
	"message.no_animation_to_import": "Nenhuma animação para importar",
	"dialog.material_instances.title": "Material",
	"dialog.animation_import.title": "Selecionar animações para importar",
	"dialog.create_texture.padding": "Preenchimento",
	"settings.fov": "FOV",
	"settings.fov.desc": "Campo de visão da câmera. O padrão é 45",
	"settings.minify_bbmodel": "Reduzir arquivos do projeto",
	"settings.minify_bbmodel.desc": "Escrever arquivos .bbmodel reduzidos em uma linha",
	"action.edit_material_instances": "Editar materiais",
	"action.edit_material_instances.desc": "Editar nomes dos materiais para blocos bedrock",
	"action.save_all_animations": "Guardas todas as animações",
	"action.save_all_animations.desc": "Salvar todas as animações carregadas",
	"action.keyframe_interpolation": "Interpolação",
	"action.keyframe_interpolation.desc": "Selecione o modo de interpolação do quadro",
	"action.keyframe_interpolation.linear": "Linear",
	"action.keyframe_interpolation.catmullrom": "Suavizar",
	"action.timeline_focus.hide_empty": "Esconder canais vazios",
	"menu.file.preferences": "Preferências",
	"menu.animation.blend_weight": "Peso dos vértices",
	"menu.animation.save": "Guardar",
	"menu.animation.properties": "Propriedades...",
	"menu.animation.file": "Ficheiro",
	"menu.animation.snapping": "Encaixar",
	"menu.animation.open_location": "Abrir local do arquivo",
	"panel.keyframe.add_data_point": "Adicionar ponto de dados do quadro",
	"panel.keyframe.remove_data_point": "Remover ponto de dados do quadro",
	"panel.keyframe.pre": "Pré",
	"panel.keyframe.post": "Pós",
	"generic.all": "Todos",
	"message.small_face_dimensions.title": "Dimensões de face incompatíveis",
	"message.small_face_dimensions.message": "A seleção contém faces que são menores que 1 unidade em uma direção. O sistema de mapeamento em UV cúbico considera qualquer face menor que esse limiar como 0 pixels de largura. A textura nessas faces pode não funcionar corretamente.",
	"message.small_face_dimensions.face_uv": "O formato atual suporta mapas UV por face, que podem lidar com faces de menores dimenções. Faça Clique Direito nos cubos afetados e mude o \"Modo UV\" para \"UV por face\"",
	"dialog.plugins.outdated_client": "Requer uma versão mais recente do Blockbench",
	"dialog.plugins.outdated_plugin": "O plugin está desatualizado e não funciona com essa versão do Blockbench",
	"settings.motion_trails": "Trilhas de movimento",
	"settings.motion_trails.desc": "Mostrar trilhas de movimento no editor de animações",
	"settings.antialiasing": "Anti-aliasing",
	"settings.antialiasing.desc": "Habilitar anti-aliasing na prévia. Reiniciar o Blockbench irá aplicar as mudanças",
	"action.timeline_frame_back": "Voltar 1 segundo",
	"action.timeline_frame_forth": "Pular 1 segundo",
	"panel.bone.ik": "Cinemática reversa (Experimental)",
	"settings.particle_tick_rate": "Taxa de tique da partícula",
	"settings.particle_tick_rate.desc": "Taxa de tiques para os efeitos da partícula em tiques por segundo. O padrão é 30",
	"action.lock_motion_trail": "Travar trilhos de movimento",
	"action.lock_motion_trail.desc": "Travar trilhos de movimento para o grupo selecionado",
	"menu.animation_file.unload": "Descarregar arquivo de animação",
	"data.null_object": "Objeto vazio",
	"status_bar.toggle_sidebar": "Habilitar barra lateral",
	"message.load_plugin_failed.title": "Falha ao carregar plugin",
	"message.load_plugin_failed.message": "Garanta que o nome do arquivo base desse plugin corresponde ao ID '%0' do plugin, como especificado em Plugin.register().",
	"dialog.project.uv_mode": "Modo UV",
	"dialog.project.uv_mode.box_uv": "Cubo UV",
	"dialog.project.uv_mode.face_uv": "UV por face",
	"dialog.project.texture_size": "Tamanho da textura",
	"dialog.animation_export.title": "Selecionar animações para exportar",
	"dialog.create_texture.rearrange_uv": "Organizar UV",
	"layout.color.subtle_text": "Texto sutil",
	"layout.color.subtle_text.desc": "Cor secundária do texto com menos contraste",
	"settings.interface_scale": "Escala da interface",
	"settings.interface_scale.desc": "Escala de toda a interface do Blockbench",
	"settings.background_rendering": "Renderizar plano de fundo",
	"settings.background_rendering.desc": "Atualizar a prévia enquanto a janela não está em foco",
	"settings.ctrl_shift_size": "Resolução Ctrl + Shift",
	"settings.ctrl_shift_size.desc": "Resolução da grade enquanto segura Control e Shift",
	"settings.hardware_acceleration": "Aceleração de Hardware",
	"settings.hardware_acceleration.desc": "Mandar tarefas de renderização para a placa de vídeo. Reinicie o Blockbench para aplicar as mudanças",
	"action.explode_skin_model": "Aumentar Modelo de Skin",
	"action.explode_skin_model.desc": "Habilita uma visão em explosão que te possibilita editar faces cobertas",
	"action.export_minecraft_skin": "Exportar Skin do Minecraft",
	"action.export_minecraft_skin.desc": "Exportar skin do Minecraft como uma textura PNG",
	"action.add_null_object": "Adicionar objeto vazio",
	"action.add_null_object.desc": "Adiciona um objeto nulo novo",
	"action.animated_texture_frame": "Quadro de textura animada",
	"action.animated_texture_frame.desc": "Definir o quadro atual da textura animada",
	"action.export_animation_file": "Exportar animações...",
	"action.export_animation_file.desc": "Exportar uma seleção de animações em um novo arquivo",
	"action.timeline_graph_editor": "Habilitar editor de grafos",
	"action.timeline_graph_editor.desc": "Habilitar a linha do tempo entre o editor de grafos e o editor de chaves",
	"menu.file.recent.clear": "Limpar arquivos recentes",
	"switches.shade": "Sombra",
	"generic.share": "Compartilhar",
	"dates.minute": "%0 Minuto",
	"dates.minutes": "%0 Minutos",
	"dates.hour": "%0 Hora",
	"dates.hours": "%0 Horas",
	"dates.day": "%0 Dia",
	"dates.days": "%0 Dias",
	"dates.week": "%0 Semana",
	"dates.weeks": "%0 Semanas",
	"dates.year": "%0 Ano",
	"dates.years": "%0 Anos",
	"message.installed_plugin": "Sucesso em instalar o plugin %0",
	"message.installed_plugin_fail": "Falha ao instalar o plugin %0",
	"dialog.share_model.title": "Compartilhar modelo",
	"dialog.share_model.expire_time": "Tempo expirado",
	"dialog.share_model.failed": "Falha em atualizar o modelo",
	"action.import_java_block_model": "Adicionar Bloco Java ou Modelo de Item",
	"action.import_java_block_model.desc": "Adicionar um Bloco Java ou Modelo de Item de um arquivo json para o modelo atual",
	"action.share_model": "Compartilhar...",
	"action.share_model.desc": "Gerar um link curto para compartilhar seu modelo",
	"action.import_project": "Importar projeto",
	"action.import_project.desc": "Importar outro projeto de um arquivo .bbmodel para o projeto atual",
	"dialog.toolbar_edit.hidden_tools": "Algumas ferramentas podem estar escondidas porque elas não estão disponíveis no modelo, formato ou situação atual.",
	"settings.camera_near_plane": "Câmera perto do plano",
	"settings.camera_near_plane.desc": "A distância mínima da câmera onde os objetos renderizam. Valores maiores diminuem o Z-fighting. O padrão é 1.",
	"mode.start.keymap_preference.desc": "Se você for novo no Blockbench e estiver vindo de outro programa 3D, você pode selecionar os atalhos do teclado para fazer sua transição mais simples. Você pode mudar os atalhos ou atalhos individuais depois nas configurações.",
	"message.load_keymap": "Você tem certeza que quer carregar esses atalhos? Isso irá sobrescrever seus atalhos atuais.",
	"message.keymap_loaded": "Atalhos carregados",
	"dialog.convert_project.current_format": "Formato atual",
	"dialog.create_texture.rearrange_uv.desc": "Criar um novo arranjamento UV para dar destaque a cada face na textura",
	"dialog.create_texture.power.desc": "Prender o tamanho da textura automática para uma potência de 2, como 64 ou 128. Isso é necessário para alguns renderers",
	"dialog.create_texture.double_use.desc": "Se dois elementos já tem o mesmo espaço UV correspondente, mantenha assim no novo mapa",
	"dialog.create_texture.padding.desc": "Adicione uma pequena pintura entre as partes individuais do template",
	"dialog.create_texture.resolution.desc": "A resolução base da textura, em pixels por metro. O tamanho real do mapa de textura pode diferir dependendo da quantidade e tamanho dos elementos.",
	"dialog.create_gif.color": "Cor de fundo",
	"dialog.save_angle.zoom": "Zoom",
	"dialog.skin.variant": "Variante",
	"dialog.flip_animation.info": "Ossos opostos são identificados pelas palavras 'esquerdo' e 'direito' com o seu nome.",
	"dialog.export_private_settings.title": "Opções privadas",
	"dialog.export_private_settings.message": "Seu arquivo contém as seguintes informações privadas: **%0**. Remova esses valores de você planeja compartilhar o arquvio com mais alguém.",
	"dialog.export_private_settings.keep": "Manter",
	"settings.timecode_frame_number": "Mostrar códigos de tempo como número do quadro",
	"settings.timecode_frame_number.desc": "Mostrar fração de códigos de tempo na linha do tempo como o número do quadro ao invés de centissegundo",
	"settings.animation_sample_rate": "Taxa de amostra da animação",
	"settings.animation_sample_rate.desc": "Taxa de amostra em amostras por segundo para curvas que o respectivo formato não suporta nativamente",
	"keybind.preview_zoom": "Zoom no campo de visão",
	"action.gradient_tool": "Ferramenta gradiente",
	"action.gradient_tool.desc": "Cria uma cor gradiente na sua textura",
	"action.import_settings": "Importar configurações",
	"action.import_settings.desc": "Importar arquivo .bbsettings",
	"action.export_settings": "Exportar configurações",
	"action.export_settings.desc": "Exportar configurações do Blockbench como um arquivo .bbsettings",
	"action.load_keymap": "Carregar mapa de atalhos",
	"action.load_keymap.default": "Padrão (Trackpad)",
	"action.load_keymap.mouse": "Padrão (Mouse)",
	"action.load_keymap.default.desc": "Atalhos padrão do Blockbench, com os controles de navegação no campo de visão otimizados para trackpads de laptops",
	"action.load_keymap.mouse.desc": "Atalhos padrão do Blockbench, com a navegação no campo de visão usando o botão do meio do mouse",
	"action.load_keymap.blender.desc": "Atalhos para usuários que são familiares com Blender",
	"action.load_keymap.cinema4d.desc": "Atalhos para usuários que são familiares com os controles do Cinema 4D",
	"action.load_keymap.maya.desc": "Atalhos para usuários que são familiares com os controles do Autodesk Maya",
	"action.import_keymap": "Importar atalhos",
	"action.import_keymap.desc": "Importar atalhos de um arquivo .bbkeymap",
	"action.export_keymap": "Exportar mapa de atalhos",
	"action.export_keymap.desc": "Exportar mapa de atalhos como um arquivo .bbkeymap",
	"action.edit_history": "Editar histórico",
	"action.edit_history.desc": "Ver o histórico de edição e voltar/refazer etapas",
	"action.group_elements": "Elementos de grupo",
	"action.group_elements.desc": "Colocar os elementos sleecionados em um novo grupo",
	"action.unfold_groups": "Desdobrar grupos",
	"action.unfold_groups.desc": "Separa todos os grupos",
	"action.edit_bedrock_binding": "Editando atalho...",
	"action.edit_bedrock_binding.desc": "Mudar a qual geometria o osso está em fronteira",
	"action.pick_screen_color": "Selecionar cor da tela",
	"action.pick_screen_color.desc": "Selecionar uma cor em qualquer lugar da sua tela",
	"action.view_mode": "Modo campo de visão",
	"action.view_mode.desc": "Mudaro campo de visão do modelo",
	"action.view_mode.textured": "Texturizado",
	"action.view_mode.solid": "Sólido",
	"action.view_mode.wireframe": "Aramado",
	"action.toggle_sidebars": "Habilitar barras laterais",
	"action.toggle_sidebars.desc": "Habilitar ou desabilitar barras laterais",
	"action.set_animation_end": "Configurar fim da animação",
	"action.set_animation_end.desc": "Configurar o fim da animação selecionada para o tempo selecionado na linha do tempo",
	"action.flip_animation": "Girar animação",
	"action.flip_animation.desc": "Gira partes da animação copiando os quadros selecionados para o outro lado do modelo",
	"action.graph_editor_zero_line": "Incluir linha zero",
	"action.graph_editor_zero_line.desc": "Se o editor de grafos sempre inclui uma linha zero no campo de visão",
	"menu.texture.render_mode": "Modo renderização",
	"menu.texture.render_mode.emissive": "Emissivo",
	"menu.texture.render_mode.layered": "Camadas",
	"menu.preview.angle.edit": "Editar ângulo...",
	"menu.animation.start_delay": "Começar delay",
	"menu.animation.loop_delay": "Loop Delay",
	"menu.animation.flip_keyframes": "Girar chaves de quadro",
	"menu.mobile_keyboard.disable_all": "Desabilitar tudo",
	"panel.keyframe.toggle_uniform_scale": "Habilitar escala uniforme",
	"camera_angle.common_isometric_right": "Direita isométrica (2:1)",
	"camera_angle.common_isometric_left": "Esquerda isométrica (2:1)",
	"camera_angle.true_isometric_right": "Habilitar direita isométrica (30°)",
	"camera_angle.true_isometric_left": "Habilitar esquerda isométrica (30°)",
	"menu.help.wiki": "Blockbench Wiki",
	"settings.update_to_prereleases": "Atualizar para Pré-lançamentos",
	"settings.update_to_prereleases.desc": "Atualize automaticamente para uma versão beta do Blockbench para testar novos recursos. Versões pre-lançamento podem ser instáveis, não ligue esta opção se depende do Blockbench para trabalhar ou para outros projetos importantes",
	"data.separator.spacer": "Espaçador",
	"data.separator.linebreak": "Quebra de Linha",
	"data.setting": "Configuração",
	"generic.select_all": "Selecionar Todos",
	"generic.select_none": "Selecionar Nenhum",
	"projects.new_tab": "Nova Aba",
	"projects.close_tab": "Fechar Aba",
	"message.invalid_format.title": "Formato Inválido",
	"message.invalid_format.message": "Este modelo foi feito no formato '%0', que não está disponível nesta instalação do Blockbench. O mais provável é que precisa de um Plug-in para abrir-lo corretamente.",
	"message.invalid_link": "Fo",
	"message.default_textures.current": "Enderço atual",
	"message.update_after_restart": "A atualisação será instalada após reiniciar",
	"message.copy_paste_tool_viewport": "Esta ferramenta só pode ser utilisada no editor 2D",
	"dialog.project.shadow_size": "Tamanho da Sombra",
	"dialog.find_replace.target": "Alvo",
	"dialog.find_replace.target.element_names": "Nomes dos Elementos",
	"dialog.find_replace.target.group_names": "Nomes dos Grupos",
	"dialog.find_replace.target.animation_names": "Nomes das Animações",
	"dialog.find_replace.target.keyframe_values": "Valores de quadro",
	"dialog.find_replace.find": "Encontrar",
	"dialog.find_replace.replace": "Substituir",
	"dialog.find_replace.regex": "Expressão Regular",
	"dialog.add_primitive.shape": "Forma",
	"dialog.add_primitive.shape.circle": "Círculo",
	"dialog.add_primitive.shape.tube": "Tubo",
	"dialog.add_primitive.shape.cone": "Cone",
	"dialog.add_primitive.shape.cylinder": "Cilindro",
	"dialog.add_primitive.shape.sphere": "Esfera",
	"dialog.add_primitive.shape.torus": "Toro",
	"dialog.add_primitive.shape.cube": "Cubo",
	"dialog.add_primitive.shape.pyramid": "Pirámide",
	"dialog.add_primitive.diameter": "Diâmetro",
	"dialog.add_primitive.height": "Altura",
	"dialog.add_primitive.sides": "Lados",
	"dialog.add_primitive.minor_diameter": "Grossura",
	"dialog.add_primitive.minor_sides": "Lados menores",
	"dialog.create_texture.combine_polys": "Combinar Ilhas",
	"dialog.create_texture.combine_polys.desc": "Formar ilhas ligadas de UV combinando faces",
	"dialog.model_stats.meshes": "Malha",
	"dialog.export_private_settings.omit": "Deixar",
	"layout.select": "Selecionar",
	"layout.options": "Opções",
	"layout.color": "Esquema de Cores",
	"layout.documentation": "Documentação",
	"layout.color.bright_ui_text": "Texto de IU claro",
	"layout.color.bright_ui_text.desc": "Texto em fundos claros",
	"layout.name": "Nome",
	"layout.author": "Autor",
	"settings.dialog.desc": "Mostrar o diálogo de \"%0\"",
	"settings.export_empty_groups": "Exportar grupos vazios",
	"settings.export_empty_groups.desc": "Incluir grupos sem conteúdo nos ficheiros exportados",
	"category.separators": "Separadores",
	"keybind.preview_area_select": "Seleção por area",
	"action.color_erase_mode": "Modo Apagar",
	"action.color_erase_mode.desc": "Com o modo de apagar ligado, ferramentas como Preencher e Retângulo subtraem cores, em vez de as adicionar.",
	"action.open_from_link": "Abrir modelo de um link...",
	"action.open_from_link.desc": "Abrir um modelo de um URL blckbn.ch",
	"action.import_obj": "Importar Modelo OBJ",
	"action.import_obj.desc": "Importa objetos de um modelo OBJ como uma Malha",
	"action.add_plugin": "Instalar Plugin",
	"action.add_plugin.desc": "Instalar um Plug-in pelo Controlo de Ações",
	"action.remove_plugin": "Desinstalar Plugin",
	"action.remove_plugin.desc": "Desinstalar um Plug-in pelo Controlo de Ações",
	"action.add_mesh": "Adicionar Malha",
	"action.add_mesh.desc": "Adiciona uma nova Malha",
	"action.add_texture_mesh": "Adicionar nova malha de textura",
	"action.add_texture_mesh.desc": "Adiciona uma nova malha de textura",
	"action.find_replace": "Encontrar/Substituir...",
	"action.find_replace.desc": "Encontra e substitui partes de nomes ou valores",
	"action.hide_everything_except_selection": "Ocultar tudo menos a seleção",
	"action.hide_everything_except_selection.desc": "Alternar a visibilidade de todos os elementos exeto os que estão selecionados",
	"action.transform_space.normal": "Normal",
	"action.selection_mode": "Modo de Selação",
	"action.selection_mode.desc": "Mudar como elementos podem ser selecionados na janela de visualização",
	"action.selection_mode.object": "Objeto",
	"action.selection_mode.face": "Face",
	"action.selection_mode.vertex": "Vértice",
	"action.create_face": "Criar face ou aresta",
	"action.create_face.desc": "Cria uma nova face ou aresta entre os vértices selecionados",
	"action.convert_to_mesh": "Converter para malha",
	"action.convert_to_mesh.desc": "Converter os elementos selecionados para malhas",
	"action.invert_face": "Inverter Face",
	"action.invert_face.desc": "Inverter as faces selecionadas de modo a fazer-las apontar na direção oposta",
	"action.extrude_mesh_selection": "Extrudir seleção",
	"action.extrude_mesh_selection.desc": "Extrudir as partes selecionadas da malha",
	"action.loop_cut": "Corte em loop",
	"action.loop_cut.desc": "Dividir a malha num loop à volta da aresta selecionada",
	"action.merge_meshes": "Juntar malhas",
	"action.merge_meshes.desc": "Junta várias malhas em uma",
	"action.keyframe_uniform": "Dilatação uniforme",
	"action.keyframe_uniform.desc": "Ligar dilatação uniforme nos quadros selecionados",
	"menu.locator.ignore_inherited_scale": "Ignorar dilatação herdada",
	"menu.texture.elements": "Aplicar a elementos",
	"uv_editor.transparent_face": "Face transparente",
	"display.pose_angle": "Ângulo de pose (só para pré-estreia)",
	"data.mesh": "Malha",
	"dialog.create_texture.type": "Tipo",
	"dialog.create_texture.type.blank": "Vazio",
	"dialog.create_texture.type.template": "Modelo de textura",
	"dialog.create_texture.type.color_map": "Modelo de cor sólida",
	"dialog.sketchfab_uploader.suggested_tags": "Tags sugeridas",
	"dialog.sketchfab_uploader.category": "Categoria",
	"dialog.sketchfab_uploader.category2": "Categoria 2",
	"layout.restore_backup": "O seu tema customisado \"%0\" foi substituido, clique aqui para o repor.",
	"layout.borders": "Bordas",
	"action.fill_mode.element": "Elemento",
	"action.inset_mesh_selection": "Indentar seleção",
	"action.inset_mesh_selection.desc": "Indenta as partes selecionadas da malha",
	"action.dissolve_edges": "Dissolver arestas",
	"action.dissolve_edges.desc": "Dissolve as arestas selecionadas numa malha e junta as faces que dividiam",
	"action.split_mesh": "Dividir malha",
	"action.split_mesh.desc": "Separar as faces selecionadas da malha para uma nova malha",
	"action.merge_vertices": "Juntar vértices",
	"action.merge_vertices.desc": "Junta os vértices selecionados para a posição do vértice que foi selecionado primeiro",
	"action.view_mode.normal": "Orientação da face",
	"action.snap_uv_to_pixels": "Forçar o UV para pixeis",
	"action.snap_uv_to_pixels.desc": "Força os vértices de UV selecionados para a gralha de pixeis",
	"menu.file.import.import_open_project": "Importar projeto aberto",
	"menu.help.unlock_projects": "Desbloquear todos os projetos",
	"status_bar.selection.faces": "%0 faces",
	"status_bar.selection.vertices": "%0 vértices",
	"message.merged_vertices": "Foram encontrados e juntados %0 vértices em %1 posições",
	"settings.vertex_merge_distance": "Distância de ajuntamento",
	"settings.vertex_merge_distance.desc": "A distância dentro da qual vértices são juntos por ajuntamento por distância",
	"settings.show_only_selected_uv": "Só mostrar o UV selecionado",
	"settings.show_only_selected_uv.desc": "So mostrar as faces UV selecionadas no editor UV por padrão",
	"action.merge_vertices.merge_all": "Juntar todos os vértices",
	"action.merge_vertices.merge_all_in_center": "Juntar todos os vértices no centro",
	"action.merge_vertices.merge_by_distance": "Juntar os vértices por distância",
	"action.merge_vertices.merge_by_distance_in_center": "Juntar por distância no centro",
	"action.uv_rotate_left": "Rodar UV para a esquerda",
	"action.uv_rotate_left.desc": "Roda as faces de UV selecionadas no sentido anti-horário",
	"action.uv_rotate_right": "Rodar UV para a direita",
	"action.uv_rotate_right.desc": "Roda as faces de UV selecionadas no sentido horário",
	"menu.uv.display_uv": "Mostrar UV",
	"menu.uv.display_uv.selected_faces": "Faces selecionadas",
	"menu.uv.display_uv.selected_elements": "Todas as faces",
	"menu.uv.display_uv.all_elements": "Todas as faces de todos os elementos",
	"menu.paste.face": "Face UV",
	"menu.paste.mesh_selection": "Seleção de malha",
	"menu.paste.outliner": "Elementos",
	"uv_editor.show_all_faces": "Mostrar todas as faces",
	"uv_editor.show_selected_faces": "Mostrar as faces selecionadas",
	"status_bar.selection.edges": "%0 arestas",
	"action.selection_mode.edge": "Aresta",
	"message.cannot_re_import.title": "Modelo não pode ser reimportado",
	"message.cannot_re_import.message": "O modelo exportado não pode ser reimportado no Blockbench novamente. Por favor grave o seu modelo como um ficheiro de projeto.",
	"generic.default": "padrão",
	"units.pixels_per_meter": "%0 Pixels para depois",
	"mode.pose": "pose",
	"modifier_actions.resize_both_sides": "Dilatar em ambas as direções",
	"modifier_actions.resize_one_side": "redimensionar em uma direção",
	"modifier_actions.draw_line": "desenhar linha",
	"modifier_actions.drag_without_snapping": "Arraste sem encaixar",
	"modifier_actions.stretch_keyframes": "Esticar quadros",
	"modifier_actions.resize_background": "Redimensionar plano de fundo",
	"modifier_actions.select_multiple": "\nSelecione multiplos",
	"modifier_actions.select_range": "selecionar intervalo",
	"modifier_actions.drag_to_duplicate": "Arraste para duplicar",
	"modifier_actions.uniform_scaling": "escala uniforme",
	"modifier_actions.snap_direction": "Direção de ajuste",
	"message.no_valid_elements": "sem elementos selecionados",
	"dialog.add_primitive.shape.plane": "plano",
	"dialog.save_angle.rotation_mode": "modo de rotação",
	"dialog.save_angle.rotation": "rotação",
	"dialog.save_angle.fov": "fov",
	"settings.hide_tab_bar": "Esconder automaticamente a barra de aba",
	"settings.hide_tab_bar.desc": "Esconder a barra de aba quando só um separador está aberto",
	"settings.status_bar_modifier_keys": "Sugerir teclas de modificador na barra de estado",
	"settings.status_bar_modifier_keys.desc": "Mostrar teclas de modificador sugeridas baseadas no contexto na barra de aba",
	"settings.ground_plane": "plana de chão",
	"settings.ground_plane.desc": "Mostrar um plano de chão abaixo do modelo",
	"settings.preview_paste_behavior": "Comportamento de colagem de visualização padrão",
	"settings.preview_paste_behavior.desc": "Selecione o comportamento quando colando algo na janela de visualização",
	"settings.preview_paste_behavior.always_ask": "Perguntar sempre",
	"action.new_window": "nova aba",
	"action.new_window.desc": "abrir nova aba do blockbench",
	"action.export_collada": "exportar collada modelo (dae)",
	"action.export_collada.desc": "exportar collada modelo (dae) para usar em outras aplicações",
	"action.paint_mode_uv_overlay": "Sobreposição UV",
	"action.paint_mode_uv_overlay.desc": "Mostrar o mapa UV sobreposto no modo de pintura",
	"action.bake_animation_into_model": "Cozer animação no modelo",
	"action.bake_animation_into_model.desc": "Cozer o quadro da animação mostrada no modelo. Só se aplica à rotação e posição, dilatação é ignorada.",
	"action.keyframe_interpolation.step": "Passo",
	"action.set_ik_target": "Definir alvo de CI",
	"action.set_ik_target.desc": "Selecionar o osso alvo que deve ser movido por este objeto nulo por Cinemática Inversa",
	"menu.action_control.type.tab": "tab",
	"menu.action_control.type.angle": "angulo de camera",
	"menu.action_control.recent_in_streamer_mode": "Tem a certeza? O modo de Streamer está ligado",
	"menu.action_control.recent_in_streamer_mode.desc": "Tem a certeza que deseja mostrar os modelos recentes?",
	"menu.tools": "feramentas",
	"menu.file.recent.more": "ver mais",
	"menu.null_object.lock_ik_target_rotation": "Bloquear a rotação do alvo IK",
	"menu.animation_file.import_remaining": "inportar restante das animações",
	"edit.loop_cut.offset": "Desvio",
	"edit.extrude_mesh_selection.extend": "estendido",
	"cube.color.pink": "rosa",
	"cube.color.silver": "prata",
	"dialog.plugins.offline": "sem conexão de internet",
	"dialog.create_texture.pixel_density": "Densidade de pixels",
	"dialog.create_texture.pixel_density.desc": "A densidade de pixels da textura, em pixels por metro. O tamanho do mapa de textura pode diferir dependendo da quantidade e tamanho dos elementos.",
	"panel.skin_pose": "pose",
	"panel.skin_pose.none": "nada",
	"panel.skin_pose.natural": "natural",
	"panel.skin_pose.walking": "andando",
	"panel.skin_pose.crouching": "Agachado",
	"panel.skin_pose.sitting": "Sentado",
	"panel.skin_pose.jumping": "pulando",
	"panel.skin_pose.aiming": "Apontar",
	"edit.loop_cut.direction": "direção",
	"data.texture_mesh": "Malha de textura",
	"generic.left": "Esquerda",
	"generic.right": "Direita",
	"mode.start.quick_setup": "Setup rápido",
	"mode.start.keymap": "Mapa-chave",
	"mode.start.quick_setup.more_themes": "Mais...",
	"dialog.resize_texture.animation_frames": "Quadros de animação",
	"dialog.export_emission_map.title": "Exportar mapa de emição",
	"dialog.export_emission_map.format": "Formato",
	"dialog.export_emission_map.format.luminance": "Luminância",
	"dialog.export_emission_map.format.luminance_inverted": "Luminância invertida",
	"dialog.export_emission_map.format.colors": "Cores",
	"dialog.export_emission_map.threshold": "Limiar de transparência",
	"dialog.export_emission_map.round_up": "Arredondar para cima para %0 × %1",
	"dialog.export_emission_map.flip_y": "Inverter o eixo Y",
	"dialog.select.type": "Tipo de elemento",
	"dialog.create_texture.max_edge_angle": "Edge Angle Threshold",
	"dialog.create_texture.max_edge_angle.desc": "The maximum angle between two faces at which they will still be combined",
	"dialog.create_texture.max_island_angle": "Island Angle Threshold",
	"dialog.create_texture.max_island_angle.desc": "The maximum angle that can be combined into the same UV island",
	"settings.mobile_panel_side": "Mobile Panel Side",
	"settings.mobile_panel_side.desc": "Select which side of the screen panels are displayed on when using Blockbench on in landscape orientation",
	"settings.obj_face_export_mode": "OBJ Face Export Mode",
	"settings.obj_face_export_mode.desc": "Choose to let the OBJ exporter convert all faces into tris or quads",
	"settings.obj_face_export_mode.both": "Default",
	"settings.obj_face_export_mode.tris": "Convert to Tris",
	"settings.obj_face_export_mode.quads": "Convert to Quads",
	"action.seam_tool": "Seam Tool",
	"action.seam_tool.desc": "Tool to define UV seams on mesh edges",
	"action.resolve_group": "Resolve Group",
	"action.resolve_group.desc": "Resolve the group while retaining its children in the same place",
	"action.move_to_group": "Move to",
	"action.move_to_group.desc": "Move the selected elements to a different outliner group or element",
	"action.select_seam": "Select UV Seam",
	"action.select_seam.desc": "Select the UV seam mode for the selected edges",
	"action.select_seam.auto": "Auto",
	"action.select_seam.join": "Join",
	"action.select_seam.divide": "Divide",
	"action.adjust_brightness_contrast": "Adjust Brightness & Contrast...",
	"action.adjust_brightness_contrast.desc": "Adjust the brightness and contrast of the selected texture",
	"action.adjust_saturation_hue": "Adjust Saturation & Hue...",
	"action.adjust_saturation_hue.desc": "Adjust the saturation and hue of the selected texture",
	"action.invert_colors": "Invert Colors",
	"action.invert_colors.desc": "Invert all colors of the selected texture",
	"action.adjust_curves": "Adjust Curves...",
	"action.adjust_curves.desc": "Adjust the brightness curves of the selected texture",
	"action.flip_texture_x": "Inverter horizontalmente",
	"action.flip_texture_y": "Inverter verticalmente",
	"action.resize_texture": "Resize Texture...",
	"action.view_mode.uv": "UV Preview",
	"action.append_to_template": "Append Elements to Template...",
	"action.append_to_template.desc": "Add the currently selected elements to the texture template",
	"action.move_texture_with_uv": "Move Texture with UV",
	"action.move_texture_with_uv.desc": "Move the texture of the face along when dragging UV faces",
	"action.timeline_setups": "Timeline Setups",
	"action.save_timeline_setup": "Save Timeline Setup...",
	"action.save_timeline_setup.desc": "Save a preset for the currently selected animators and channels",
	"menu.texture": "Texture",
	"menu.texture.render_mode.default": "Default",
	"menu.texture.merge_onto_texture": "Merge Onto Texture Above",
	"menu.animation.unload": "Unload",
	"panel.timeline": "Timeline",
	"action.pan_tool": "Pan Tool",
	"action.pan_tool.desc": "Tool to navigate in the viewport and the texture editor",
	"mode.start.recent.favorite": "Mark as Favorite",
	"mode.start.info": "Info",
	"mode.start.target": "Target",
	"mode.start.start": "Start",
	"mode.start.create_new": "Create New Model",
	"mode.start.format.informations": "Good to know:",
	"mode.start.format.resources": "Resources:",
	"format.free.info.meshes": "In this format, you can create low poly models using cubes and custom shaped meshes.",
	"format.free.info.limitation": "Models cannot be loaded into games that need specialized formats, such as Minecraft.",
	"format.skin.info.skin": "This format is designed to create Minecraft skins and entity textures.",
	"format.skin.info.model": "The model cannot be changed. In order to make changes to the model, first convert to a different format via **File** > **Convert Project**.",
	"format.java_block.info.rotation": "Rotations are limited to one axis per element",
	"format.java_block.info.size": "The model is limited to a size of 3 by 3 by 3 blocks. Display settings can make item models larger though",
	"format.java_block.info.animation": "This format does not support animations in vanilla Minecraft. If you are creating a mod, you can use GeckoLib to animate models. If not, the only way to animate is to switch out the model using commands or animated textures.",
	"format.bedrock.info.textures": "Each model can only have one texture",
	"format.bedrock_block": "Bedrock Block",
	"format.bedrock_block.desc": "Block model for Minecraft Bedrock Edition",
	"format.modded_entity.info.integer_size": "The size of individual cubes is limited to integers.",
	"format.modded_entity.info.format": "Models are written in Java code instead of dedicated data structures like all other Blockbench export formats.",
	"format.optifine_entity.info.optifine_required": "Users without OptiFine installed won't see the model.",
	"format.optifine_entity.info.pivots": "Bone pivots are locked, so it is a good idea to leave them untouched.",
	"format_category.low_poly": "Low-Poly",
	"format_category.minecraft": "Minecraft",
	"format_category.other": "Other",
	"format_category.loaders": "Loaders",
	"message.recover_backup.recover": "Recover",
	"message.invalid_characters.title": "Invalid Path",
	"message.invalid_characters.message": "The path of the imported file contains invalid characters, uppercase letters, or white spaces. The supported characters are: %0",
	"dialog.share_model.thumbnail": "Thumbnail",
	"dialog.skin.high_res_texture": "Please note that skins with the selected resolution will not work as regular Minecraft skins. Select a lower resolution.",
	"settings.allow_display_slot_mirror": "Allow Display Slot Mirroring",
	"settings.allow_display_slot_mirror.desc": "Allow Display slots for Java item models to be mirrored. WARNING: This only works in Minecraft 1.14 or earlier or in special cases.",
	"action.switch_tabs": "Switch Tabs",
	"action.switch_tabs.desc": "Cycle between opened tabs. Hold shift to cycle in the opposite direction.",
	"action.unselect_all": "Unselect All",
	"action.save_palette": "Save Palette...",
	"action.save_palette.desc": "Save the current color palette inside Blockbench for later use",
	"action.keyframe_column_create": "Create Keyframe Column",
	"action.keyframe_column_create.desc": "Key all channels in the timeline at the current timecode, if they already have keyframes",
	"action.keyframe_column_select": "Select Keyframe Column",
	"action.keyframe_column_select.desc": "Select all keyframes in the timeline along a column below the playhead",
	"menu.uv": "UV",
	"menu.keyframe": "Keyframe",
	"menu.palette.load.update": "Update Palette",
	"menu.palette.load.update.desc": "Updates this palette with the colors of the current Blockbench palette",
	"menu.timeline_marker.set_time": "Set Time...",
	"uv_editor.scale_uv": "Scale UV",
	"action.preview_scene": "Preview Scene",
	"action.preview_scene.desc": "Change the model preview scene",
	"preview_scene.minecraft_overworld": "Overworld",
	"preview_scene.minecraft_nether": "Nether",
	"preview_scene.minecraft_end": "End",
	"dialog.project.modded_entity_flip_y": "Inverter o eixo Y",
	"preview_scene.studio": "Studio",
	"format.image": "Image",
	"modifier_actions.set_copy_source": "Set Copy Source",
	"message.load_images.title": "Load Images",
	"message.load_images.edit_image": "Edit Image",
	"dialog.add_primitive.align_edges": "Align Edges",
	"dialog.flip_animation.show_in_timeline": "Mostrar ossos modificados na reta cronológica",
	"settings.default_cube_size": "Cube Size",
	"settings.default_cube_size.desc": "Set the default cube size when creating a new cube",
	"settings.uniform_keyframe": "Uniform Scale Keyframes",
	"settings.uniform_keyframe.desc": "Set scale keyframes to uniform scaling by default",
	"settings.nearest_rectangle_select": "Rectangle Selection: Nearest Edge",
	"settings.nearest_rectangle_select.desc": "Snap rectangle selections to the nearest pixel edge, like in GIMP, instead of entire pixels.",
	"settings.pick_color_opacity": "Pick Color Opacity",
	"settings.pick_color_opacity.desc": "Pick the color opacity with the Color Picker and set it as brush opacity",
	"settings.paint_with_stylus_only": "Paint with Stylus Only",
	"settings.paint_with_stylus_only.desc": "Only use the stylus for painting, reserve mouse or touch input for navigation.",
	"action.copy_brush_mode": "Copy Brush Mode",
	"action.copy_brush_mode.copy": "Copy",
	"action.copy_brush_mode.pattern": "Pattern",
	"action.copy_brush_mode.sample": "Sample",
	"action.brush_shape": "Brush Shape",
	"action.brush_shape.square": "Square",
	"action.brush_shape.circle": "Circle",
	"action.blend_mode": "Blend Mode",
	"action.blend_mode.default": "Default",
	"action.blend_mode.set_opacity": "Set Opacity",
	"action.blend_mode.color": "Color",
	"action.blend_mode.behind": "Behind",
	"action.blend_mode.multiply": "Multiply",
	"action.blend_mode.divide": "Divide",
	"action.blend_mode.add": "Add",
	"action.blend_mode.subtract": "Subtract",
	"action.blend_mode.screen": "Screen",
	"action.blend_mode.overlay": "Overlay",
	"action.blend_mode.hard_light": "Hard Light",
	"action.blend_mode.difference": "Difference",
	"action.copy_brush": "Copy Brush",
	"action.copy_brush.desc": "Brush to clone parts of your texture or draw patterns. Hold Ctrl and click to select a copy source.",
	"action.validator_window": "View Model Issues...",
	"action.validator_window.desc": "Opens the validator, which lists issues with the current model.",
	"action.cancel_gif": "Cancel GIF",
	"menu.text_edit.copy_vector": "Copy Vector",
	"menu.brush_presets.dialog": "Brush Presets...",
	"menu.brush_presets.pixel_brush": "Pixel Brush",
	"menu.brush_presets.smooth_brush": "Smooth Brush",
	"menu.texture.edit_in_blockbench": "Edit in Blockbench",
	"menu.mirror_painting.axis": "Axis",
	"menu.mirror_painting.axis.desc": "Select on which axis paint strokes will get mirrored",
	"menu.mirror_painting.global": "Global Symmetry",
	"menu.mirror_painting.global.desc": "Enabled mirror painting on the model in global space",
	"menu.mirror_painting.local": "Local Symmetry",
	"menu.mirror_painting.local.desc": "Enable mirror painting in local space for each element",
	"menu.mirror_painting.texture_frames": "Repeat on Flipbook Frames",
	"menu.mirror_painting.texture_frames.desc": "Mirror paint strokes to every frame of animated textures",
	"format.bedrock_block.info.size_limit": "Size total size of a block is limited to 30 pixels in all dimensions. The limit can be off-centered in all directions by 7 pixels from the block center.",
	"format.bedrock_block.info.textures": "Multiple textures can be applied to different cubes in Blockbench, but require additional setup in the behavior pack to work correctly in-game.",
	"format.image.desc": "Edit images in the 2D image editor",
	"generic.delete_all": "Delete All",
	"message.child_model_only.open": "Open Parent Model",
	"dialog.project.credit": "Credit",
	"dialog.convert_project.create_copy": "Create Copy",
	"dialog.texture.frame_time": "Frame Time",
	"dialog.texture.frame_time.desc": "Set for how long each frame will be visible, in ticks. Each tick is 1/20th of a second.",
	"dialog.texture.frame_interpolate": "Interpolate",
	"dialog.texture.frame_interpolate.desc": "Interpolate between animation frames by cross-fading to the next frame",
	"dialog.texture.frame_order_type": "Loop Mode",
	"dialog.texture.frame_order_type.loop": "Loop",
	"dialog.texture.frame_order_type.backwards": "Loop Backwards",
	"dialog.texture.frame_order_type.back_and_forth": "Back-and-Forth",
	"dialog.texture.frame_order_type.custom": "Custom Order",
	"dialog.texture.frame_order": "Frame Order",
	"dialog.texture.frame_order.desc": "Set a custom frame order by listing frame indices in a new order. Frame indices start at 0 with the first frame.",
	"dialog.select.mode": "Mode",
	"dialog.select.mode.new": "New Selection",
	"dialog.select.mode.add": "Add to Selected",
	"dialog.select.mode.remove": "Remove from Selected",
	"dialog.select.mode.in_selection": "Select only from Selected",
	"dialog.predicate_overrides.model": "Model",
	"dialog.predicate_overrides.predicates": "Predicates",
	"dialog.predicate_overrides.variants": "Variants",
	"dialog.predicate_overrides.start_value": "Start",
	"dialog.predicate_overrides.add_override": "Add Override",
	"dialog.predicate_overrides.add_predicate": "Add Predicate",
	"dialog.predicate_overrides.generate_overrides": "Generate Overrides",
	"dialog.predicate_overrides.confirm_delete": "Are you sure you want to delete all overrides?",
	"dialog.predicate_overrides.predicate.angle": "Compass Angle",
	"dialog.predicate_overrides.predicate.blocking": "Is Blocking",
	"dialog.predicate_overrides.predicate.broken": "Is Broken",
	"dialog.predicate_overrides.predicate.cast": "Is Cast",
	"dialog.predicate_overrides.predicate.cooldown": "Cooldown",
	"dialog.predicate_overrides.predicate.damage": "Damage",
	"dialog.predicate_overrides.predicate.damaged": "Is Damaged",
	"dialog.predicate_overrides.predicate.lefthanded": "Is Left-Handed",
	"dialog.predicate_overrides.predicate.pull": "Pull Amount",
	"dialog.predicate_overrides.predicate.pulling": "Is Pulling",
	"dialog.predicate_overrides.predicate.charged": "Is Charged",
	"dialog.predicate_overrides.predicate.firework": "Has Firework",
	"dialog.predicate_overrides.predicate.throwing": "Ready to Throw",
	"dialog.predicate_overrides.predicate.time": "Time of Day",
	"dialog.predicate_overrides.predicate.custom_model_data": "Custom Model Data",
	"dialog.predicate_overrides.predicate.level": "Light Level",
	"dialog.predicate_overrides.predicate.filled": "Bundle Fill Level",
	"dialog.predicate_overrides.predicate.tooting": "Tooting",
	"settings.model_export_scale": "Model Export Scale",
	"settings.model_export_scale.desc": "Factor by which the scale of exported glTF, DAE, and FBX models gets reduced. The default is 16, which converts 16 Blockbench units into 1 meter in the export.",
	"action.export_fbx": "Export FBX Model",
	"action.export_fbx.desc": "Export model and animations as fbx file to use it in other 3D applications and game engines",
	"action.center_lateral": "Center Lateral",
	"action.center_lateral.desc": "Center the selected elements on the X and Z axis",
	"action.adjust_opacity": "Adjust Opacity...",
	"action.adjust_opacity.desc": "Adjust the opacity of the selected texture",
	"action.rotate_texture_cw": "Rotate Clockwise",
	"action.rotate_texture_ccw": "Rotate Counter-clockwise",
	"action.predicate_overrides": "Edit Predicate Overrides...",
	"action.predicate_overrides.desc": "Select models to override this model based on selected conditions",
	"action.auto_set_cullfaces": "Set Cullfaces Automatically",
	"action.auto_set_cullfaces.desc": "Automatically generate cullfaces to hide faces when they are covered by the neighboring block.",
	"menu.texture.edit_externally": "Edit Externally",
	"menu.mirror_painting.texture": "2D Editor Symmetry",
	"menu.mirror_painting.texture.desc": "Enable mirror painting in 2D space on the image or texture",
	"menu.animator.rotation_global": "Rotate in Global Space",
	"uv_editor.face_properties": "Face Properties",
	"uv_editor.face_properties.material_instance": "Material Instance",
	"uv_editor.tint.info": "Tint can be enabled on a face to tell Minecraft to tint it. In vanilla, tint can only be used by specific blocks such as leaves and redstone dust, and can only have a value of 0.",
	"uv_editor.cullface.info": "Enabling cullface tells a face on a block to unrender if another full block is placed next to it in the specified direction in your Minecraft world. This can be used to optimize performance.",
	"uv_editor.material_instance.info": "Material instances can be set to a user-defined name. That name can be used in the block JSON file in the behavior pack to assign a particular texture and material that the face.",
	"display.reference.frame_invisible": "Item Frame (Invisible)",
	"data.settings_profile": "Profile",
	"message.display_skin.invalid_name": "Cannot find Minecraft account with the name \"%0\".",
	"dialog.load_plugins_from_query.title": "Load Plugins",
	"dialog.load_plugins_from_query.text": "You used a link that requires plugins to be installed. Would you like to install them?",
	"dialog.select_model.title": "Select Model",
	"dialog.select_model.bones": "Bones",
	"dialog.select_model.cubes": "Cubes",
	"dialog.settings.create_profile": "Create Profile...",
	"settings_profile.confirm_delete": "Are you sure you want to delete this settings profile?",
	"settings_profile.condition.type.selectable": "Manually Selectable",
	"settings.interface_mode": "UI Mode",
	"settings.interface_mode.desc": "Interface mode",
	"settings.interface_mode.auto": "Automatic",
	"settings.interface_mode.desktop": "Desktop",
	"settings.interface_mode.mobile": "Mobile",
	"settings.paint_through_transparency": "Paint Through Transparency",
	"settings.paint_through_transparency.desc": "Paint through transparent pixels when Lock Alpha Channel is enabled",
	"action.tab_overview": "Tab Overview",
	"action.tab_overview.desc": "View all open tabs in a grid and jump to one",
	"action.slider_color_red": "Color Red",
	"action.slider_color_green": "Color Green",
	"action.slider_color_blue": "Color Blue",
	"action.add_animation_controller": "Adicionar Controlador de Animação",
	"action.add_animation_controller.desc": "Create a blank animation controller",
	"action.animation_controller_preview_mode": "Controller Preview",
	"action.animation_controller_preview_mode.paused": "Paused",
	"action.animation_controller_preview_mode.manual": "Manual Preview",
	"action.animation_controller_preview_mode.play": "Auto Play",
	"action.keyframe_interpolation.bezier": "Bézier",
	"action.keyframe_bezier_linked": "Link Bézier Handles",
	"action.keyframe_bezier_linked.desc": "Connect the right and left keyframe bézier handle",
	"action.reset_keyframe_handles": "Reset Keyframe Handles",
	"action.reset_keyframe_handles.desc": "Reset the bézier handles of the selected keyframes",
	"action.looped_animation_playback": "Looped Playback",
	"action.looped_animation_playback.desc": "Preview animations in an infinite loop",
	"timeline.bind_to_actor": "Bind to Actor",
	"animation_controllers.select_preset": "Select a controller preset...",
	"animation_controllers.state.animations": "Animations",
	"animation_controllers.state.particles": "Particles",
	"animation_controllers.state.sounds": "Sounds",
	"animation_controllers.state.on_entry": "On Entry",
	"animation_controllers.state.on_exit": "On Exit",
	"animation_controllers.state.transitions": "Transitions",
	"animation_controllers.state.condition": "Condition",
	"animation_controllers.state.blend_transition": "Blend Time",
	"animation_controllers.state.shortest_path": "Blend by Shortest Path",
	"animation_controllers.state.edit_transition": "Edit Transition",
	"menu.color_picker.picker_type": "Picker Type",
	"menu.color_picker.picker_type.square": "Square",
	"menu.color_picker.picker_type.wheel": "Wheel",
	"menu.color_picker.slider_mode": "Slider Mode",
	"menu.color_picker.slider_mode.hsv": "Hue, Saturation, Value",
	"menu.color_picker.slider_mode.rgb": "Red, Green, Blue",
	"menu.texture.render_mode.additive": "Additive",
	"panel.color.picker_options": "Color Picker Options",
	"panel.animation_controllers": "Animation Controller",
	"display.preset.armor_stand": "Ground (Armor Stand)",
	"data.file_path": "File Path",
	"dialog.extrude.orientation": "Orientation",
	"dialog.extrude.orientation.upright": "Upright X",
	"dialog.extrude.orientation.flat": "Flat",
	"dialog.scale.box_uv_warning": "Scaling cubes that use Box UV may break the UV mapping. Instead, try to scale your model during implementation, or switch to Per-face UV Mode in File > Project or per cube.",
	"dialog.create_gif.format": "Format",
	"dialog.create_gif.format.gif": "GIF",
	"dialog.create_gif.format.png_sequence": "PNG Sequence",
	"dialog.create_gif.pixelate": "Pixelate",
	"dialog.create_gif.bg_image": "Background Image",
	"dialog.create_gif.turn.desc": "Rotate the model while recording. Use negative values to turn the model clockwise. A value of 60 corresponds to one rotation every second.",
	"settings_profile.condition": "Condition",
	"settings_profile.condition.type.file_path.desc": "Use Regular Expression syntax to match the file path of the current project. Use forward slashes for directories",
	"settings.only_selected_bezier_handles": "Show Only Selected Bézier Handles",
	"settings.only_selected_bezier_handles.desc": "Hide handles of bézier keyframes that are not currently selected",
	"settings.embed_textures": "Embed Textures",
	"settings.embed_textures.desc": "Embed texture file content in .bbmodel files",
	"action.selection_mode.cluster": "Cluster",
	"dialog.copied_to_clipboard": "Copied to clipboard",
	"data.reference_image": "Reference Image",
	"message.delete_reference_image": "Are you sure you want to delete this reference image? This cannot be undone.",
	"message.add_reference_image.message": "Select where to load the reference image",
	"message.import_particle_texture.import": "Import Particle Texture",
	"message.import_particle_texture.message": "Would you like to import a texture file to be used for your particle?",
	"message.save_codec_selector.title": "Save Model Format",
	"message.save_codec_selector.message": "Select a format to save the model in.",
	"message.save_codec_selector.project_file": "Blockbench Project (.bbmodel)",
	"message.save_codec_selector.both": "Both",
	"message.display_skin.username": "Username (Java)",
	"message.palette_locked": "The palette is locked",
	"dialog.project.default_uv_mode": "Default UV Mode",
	"dialog.project.default_uv_mode.description": "Default UV Mode of the project. The UV mode can also be changed per cube.",
	"dialog.export_options.title": "Export Options",
	"dialog.edit_texture.preview": "Preview",
	"dialog.proportional_editing.range": "Range",
	"dialog.proportional_editing.falloff": "Falloff",
	"dialog.proportional_editing.falloff.linear": "Linear",
	"dialog.proportional_editing.falloff.hermite_spline": "Smooth",
	"dialog.proportional_editing.falloff.constant": "Constant",
	"dialog.proportional_editing.selection": "Selection",
	"dialog.proportional_editing.selection.linear": "Linear Distance",
	"dialog.proportional_editing.selection.connections": "Connections",
	"dialog.mirror_painting_texture_center.middle": "Middle",
	"dialog.mirror_painting_texture_center.custom": "Custom",
	"dialog.settings.reset_to_default": "Reset to Default",
	"keybindings.item.num_slider.increase": "Increase",
	"keybindings.item.num_slider.decrease": "Decrease",
	"settings.always_show_splash_art": "Always Show Splash Art",
	"settings.always_show_splash_art.desc": "Always display the splash art on the start screen",
	"action.slider_palette_color": "Switch Palette Color",
	"action.slider_palette_color.desc": "Cycle between the colors in the palette",
	"action.proportional_editing": "Proportional Editing",
	"action.proportional_editing.desc": "Proportionally affect surrounding vertices when editing parts of a mesh",
	"action.limit_to_palette": "Limit to Palette",
	"action.limit_to_palette.desc": "Limits the colors of the texture to those in the currently loaded palette",
	"action.edit_reference_images": "Edit Reference Images",
	"action.edit_reference_images.desc": "Turn on reference image mode to add or edit reference images and blueprints",
	"action.add_reference_image": "Add Reference Image",
	"action.reference_image_from_clipboard": "Paste Reference Image",
	"action.reference_image_list": "Reference Images",
	"action.connect_uv_faces": "Connect UV Faces",
	"action.connect_uv_faces.desc": "Connect the selected UV faces to the last selected UV face",
	"action.merge_uv_vertices": "Merge UV Vertices",
	"action.merge_uv_vertices.desc": "Snap the first selected UV vertices to the last selected UV vertices",
	"action.bedrock_animation_mode": "Bedrock Animation Mode",
	"action.bedrock_animation_mode.desc": "Select the mode to edit animations for Minecraft: Bedrock Edition in",
	"action.bedrock_animation_mode.entity": "Entity",
	"action.bedrock_animation_mode.attachable_first": "Item 1st Person",
	"action.bedrock_animation_mode.attachable_third": "Item 3rd Person",
	"timeline.amplify": "Amplify",
	"menu.options": "Options...",
	"menu.palette.lock_palette": "Lock Palette",
	"menu.uv.export": "Export UV Mapping",
	"menu.uv.flip_x": "Mirror X",
	"menu.uv.flip_y": "Mirror Y",
	"menu.mirror_painting.enabled": "Enabled",
	"reference_image.position": "Position",
	"reference_image.size": "Size",
	"reference_image.rotation": "Rotation",
	"reference_image.opacity": "Opacity",
	"reference_image.visibility": "Visibility",
	"reference_image.clear_mode": "Clear Mode",
	"reference_image.layer": "Layer",
	"reference_image.layer.background": "Behind Model",
	"reference_image.layer.viewport": "Above Model",
	"reference_image.layer.float": "Above Interface",
	"reference_image.scope": "Scope",
	"reference_image.scope.project": "Just this project",
	"reference_image.scope.global": "All projects",
	"reference_image.enabled_modes": "Enabled in Modes",
	"codec.common.encoding": "Encoding",
	"codec.common.armature": "Export Groups as Armature",
	"codec.common.export_animations": "Export Animations",
	"codec.common.embed_textures": "Embed Textures",
	"preview.center_camera": "Center Camera",
	"display.reference.frame_top": "Item Frame Top",
	"display.reference.frame_top_invisible": "Item Frame Top (Invisible)",
	"action.proportional_editing_range": "Proportional Editing Range",
	"action.proportional_editing_range.desc": "Adjust the range for proportional editing",
	"action.toggle_all_reference_images": "Hide/Show All Reference Images",
	"action.toggle_all_reference_images.desc": "Toggle the visibility of all reference images at once",
	"action.add_animation_controller_state": "Add Animation Controller State",
	"action.add_animation_controller_state.desc": "Add a new state to the animation controller",
	"menu.slider.round_value": "Round Value",
	"texture.error.too_large": "Resolution exceeds the maximum of %0",
	"dialog.copy_to_clipboard": "Copy to clipboard",
	"dialog.open_url": "Open URL",
	"reference_image.image": "Image",
	"uv_editor.rotate_uv": "Rotate UV",
	"generic.error": "Error",
	"projects.start_screen": "Start Screen",
	"message.invalid_link.message": "The shared model \"%0\" that you are trying to load is either invalid or has expired.",
	"message.plugin_dependencies.title": "Plugin Dependencies",
	"message.plugin_dependencies.message1": "The plugin requires these dependencies:",
	"message.plugin_dependencies.message1_update": "The plugin %0 has been updated and now requires these dependencies:",
	"message.plugin_dependencies.message2": "Do you want to install them to continue?",
	"message.plugin_dependencies.invalid": "Unfortunately the plugin cannot be installed, it has an invalid dependency:",
	"message.preview_scene_load_failed": "Failed to load preview scene. Check your internet connection.",
	"dialog.convert_project.text1": "Convert the project into a different format.",
	"dialog.convert_project.text2": "Use conversion at your own risk. Formats have different features and restrictions, so converting will in some cases break parts of your project.",
	"dialog.convert_project.text3": "You cannot undo converting, that is why by default a copy will be created.",
	"dialog.unsaved_work.title": "Unsaved Work",
	"dialog.unsaved_work.text": "The following projects contain unsaved changes. Do you want to save your changes?",
	"dialog.unsaved_work.discard_all": "Discard All",
	"dialog.unsaved_work.save_all": "Save All",
	"dialog.resize_texture.mode": "Mode",
	"dialog.resize_texture.mode.crop": "Crop/Expand",
	"dialog.resize_texture.mode.scale": "Scale",
	"dialog.plugins.is_installed": "Installed",
	"dialog.plugins.is_disabled": "Disabled",
	"dialog.plugins.disable": "Disable",
	"dialog.plugins.enable": "Enable",
	"dialog.plugins.dependencies": "Depends on:",
	"dialog.view_backups.open_folder": "Open Folder",
	"dialog.share_model.reference_images": "Include Reference Images",
	"dialog.share_model.too_large": "Failed to upload: Model is too large",
	"dialog.share_model.too_large_references": "Failed to upload: Model is too large. Try without reference images.",
	"settings.stretch_linked": "Link Stretching",
	"settings.stretch_linked.desc": "Stretch the cube in all directions with the same value",
	"settings.grids": "Show Grids",
	"settings.grids.desc": "Show or hide all 3D grids",
	"settings.double_click_switch_tools": "Switch Tools on Double Click",
	"settings.double_click_switch_tools.desc": "Double click the viewport to switch between tools",
	"settings.outlines_in_paint_mode": "Selection Outlines in Paint Mode",
	"settings.outlines_in_paint_mode.desc": "Display element selection outlines while in paint mode",
	"settings.json_indentation": "JSON Indentation",
	"settings.json_indentation.desc": "Indentation style for exported JSON files",
	"settings.json_indentation.tabs": "Tabs",
	"settings.json_indentation.spaces_4": "Spaces: 4",
	"settings.json_indentation.spaces_2": "Spaces: 2",
	"action.slider_stretch": "Stretch",
	"action.slider_stretch.desc": "Stretches cubes multiplicatively on the %0 axis without changing the UV",
	"action.view_backups": "View Backups",
	"action.view_backups.desc": "Browse the list of auto-saved project backups",
	"action.search_outliner": "Search Outliner",
	"action.search_outliner.desc": "Search for specific element names in the outliner",
	"action.mirror_modeling": "Mirror Modeling",
	"action.mirror_modeling.desc": "Enable Mirror Modeling on the X axis. All changes you make in the viewport will be reflected to the other side, unless specifically disabled on the element.",
	"action.allow_element_mirror_modeling": "Allow Mirror Modeling",
	"action.allow_element_mirror_modeling.desc": "Choose whether the selected elements can be affected by mirror modeling",
	"action.switch_face_crease": "Switch Face Crease",
	"action.switch_face_crease.desc": "Switch in which direction the quad folds in the middle",
	"action.clear_unused_texture_space": "Clear Unused Texture Space",
	"action.clear_unused_texture_space.desc": "Clear parts of the texture that are not UV-mapped to any elements",
	"action.split_screen": "Split Screen",
	"action.split_screen.desc": "Select a viewport split screen mode",
	"action.split_screen.single": "Single",
	"action.split_screen.double_horizontal": "Double Horizontal",
	"action.split_screen.double_vertical": "Double Vertical",
	"action.split_screen.quad": "Quad",
	"action.split_screen.triple_left": "Triple Left",
	"action.split_screen.triple_right": "Triple Right",
	"action.split_screen.triple_top": "Triple Top",
	"action.split_screen.triple_bottom": "Triple Bottom",
	"action.uv_project_from_view": "UV Project from View",
	"action.uv_project_from_view.desc": "Automatically generate UVs for the selected faces from the perspective of the 3D view",
	"action.graph_editor_other_graphs": "Display Other Graphs",
	"action.graph_editor_other_graphs.desc": "Whether the graphs of the axes that are not selected are displayed",
	"action.graph_editor_include_other_graphs": "Include Other Graphs",
	"action.graph_editor_include_other_graphs.desc": "Whether the graph editor includes the graphs that are not selected in the view",
	"action.set_ik_source": "Set IK Root",
	"action.set_ik_source.desc": "Select the root bone of the chain that should be moved by this null object via Inverse Kinematics",
	"edit.loop_cut.cuts": "Cuts",
	"panel.element.stretch": "Stretch",
	"preview_scene.minecraft_plains": "Plains",
	"preview_scene.minecraft_cherry_grove": "Cherry Grove",
	"preview_scene.minecraft_snowy_tundra": "Snowy Tundra",
	"preview_scene.minecraft_sunset": "Sunset",
	"preview_scene.minecraft_night": "Night",
	"preview_scene.minecraft_desert": "Desert",
	"preview_scene.minecraft_underwater": "Underwater",
	"preview_scene.minecraft_coral_reef": "Coral Reef",
	"preview_scene.minecraft_lush_cave": "Lush Cave",
	"preview_scene.minecraft_deep_dark": "Deep Dark",
	"generic.navigate_forward": "Forward",
	"generic.navigate_back": "Back",
	"action.element_render_order": "Transparency Render Order",
	"action.element_render_order.default": "Auto",
	"action.element_render_order.behind": "Behind",
	"action.element_render_order.in_front": "In Front",
	"message.installing_update.title": "Update Available",
	"message.installing_update.message": "A new version is ready to be installed. After closing the app, please allow for around %0 seconds before opening Blockbench again or turning off the computer, for the update to be installed.",
	"settings.brush_cursor_2d": "2D Brush Cursor",
	"settings.brush_cursor_2d.desc": "Display an outline around the brush in the 2D workspace",
	"settings.brush_cursor_3d": "3D Brush Cursor",
	"settings.brush_cursor_3d.desc": "Display an outline around the brush in the 3D workspace",
	"settings.cdn_mirror": "Use CDN Mirror",
	"settings.cdn_mirror.desc": "Use the mirror CDN to download plugins. The mirror receives updates faster and works in some regions where the default does not work.",
	"data.layer": "Layer",
	"data.panel": "Panel",
	"generic.confirm_delete": "Are you sure you want to delete this?",
	"format_category.general": "General",
	"modifier_actions.no_uniform_scaling": "Free Scaling",
	"message.texture_refresh_conflict.title": "Conflicting Texture Versions",
	"message.texture_refresh_conflict.message": "The texture file might contain changes that conflict with Blockbench's version",
	"message.texture_refresh_conflict.keep_ours": "Keep Blockbench's version",
	"message.texture_refresh_conflict.keep_theirs": "Load file and discard all changes and layers in Blockbench",
	"message.group_required_to_animate": "You cannot animate this type of element. Create a group or armature to animate it.",
	"dialog.texture.uv_size": "UV Size",
	"dialog.advanced_screenshot.angle_preset": "Angle Preset",
	"dialog.advanced_screenshot.resolution": "Resolution",
	"dialog.advanced_screenshot.zoom_to_fit": "Zoom To Fit",
	"dialog.advanced_screenshot.zoom": "Zoom / Focal Length",
	"dialog.advanced_screenshot.anti_aliasing": "Anti-aliasing",
	"dialog.advanced_screenshot.anti_aliasing.off": "Off",
	"dialog.advanced_screenshot.anti_aliasing.msaa": "Multisampling",
	"dialog.advanced_screenshot.anti_aliasing.ssaa": "Supersampling",
	"dialog.advanced_screenshot.show_gizmos": "Show Edit Gizmos",
	"dialog.advanced_screenshot.shading": "Shading",
	"settings.auto_keyframe": "Auto Keyframe",
	"settings.auto_keyframe.desc": "Automatically create a keyframe with default values at the timeline start when transforming the bone at a later point",
	"settings.modded_entity_integer_size": "Modded Entity Integer Size",
	"settings.modded_entity_integer_size.desc": "Limit cube sizes in the Modded Entity format to integers. While floats are technically supported in some versions, integers are much easier to UV-map.",
	"category.layers": "Layers",
	"keybind.paint_secondary_color": "Paint with Secondary Color",
	"action.selection_tool_operation_mode": "Selection Operation Mode",
	"action.selection_tool_operation_mode.create": "New Selection",
	"action.selection_tool_operation_mode.add": "Add to Selection",
	"action.selection_tool_operation_mode.subtract": "Subtract from Selection",
	"action.selection_tool_operation_mode.intersect": "Intersect",
	"action.pixel_perfect_drawing": "Pixel Perfect Drawing",
	"action.pixel_perfect_drawing.desc": "Draw smooth pixel-art lines without double pixels at curves",
	"action.selection_tool": "Selection Tool",
	"action.selection_tool.desc": "Select parts of the image",
	"action.selection_tool.rectangle": "Rectangle",
	"action.selection_tool.ellipse": "Ellipse",
	"action.selection_tool.lasso": "Lasso Select",
	"action.selection_tool.wand": "Magic Wand",
	"action.selection_tool.color": "Same Color",
	"action.move_layer_tool": "Move Layer",
	"action.move_layer_tool.desc": "Move the current layer or selection",
	"action.export_modded_animations": "Export Modded Entity Animations",
	"action.export_modded_animations.desc": "Export animations for a Minecraft Java Edition modded entity model",
	"action.swap_colors": "Swap Colors",
	"action.swap_colors.desc": "Swap the main color with the secondary color",
	"action.apply_mesh_rotation": "Apply Rotation",
	"action.apply_mesh_rotation.desc": "Reset the element rotation of the mesh, and apply it to the geometry instead",
	"action.flip_texture_x.desc": "Flip the texture or layer horizontally",
	"action.flip_texture_y.desc": "Flip the texture or layer vertically",
	"action.rotate_texture_cw.desc": "Rotate the texture or layer clockwise",
	"action.rotate_texture_ccw.desc": "Rotate the texture or layer counter-clockwise",
	"action.crop_texture_to_selection": "Crop Texture to Selection",
	"action.create_empty_layer": "Create Empty Layer",
	"action.enable_texture_layers": "Enable Layers",
	"action.disable_texture_layers": "Disable Layers",
	"action.layer_opacity": "Layer Opacity",
	"action.layer_to_texture_size": "Expand Layer to Texture Size",
	"action.layer_to_texture_size.desc": "Expand the layer to the size of the texture",
	"action.merge_layer_down": "Merge Down",
	"action.merge_layer_down.desc": "Merge into the layer below",
	"action.advanced_screenshot": "Advanced Screenshot...",
	"action.advanced_screenshot.desc": "Take a screenshot of the model with advanced options",
	"action.bake_ik_animation": "Bake Inverse Kinematics",
	"action.bake_ik_animation.desc": "Bake the rotations applied by inverse kinematics into the selected animation",
	"action.save_animation_preset": "Save Animation Preset...",
	"action.save_animation_preset.desc": "Save the selected keyframes as an animation preset",
	"action.animation_onion_skin": "Animation Onion Skin",
	"action.animation_onion_skin.desc": "Display an wireframe view of a different frame in the animation for reference",
	"action.apply_animation_preset": "Apply Animation Preset",
	"action.apply_animation_preset.desc": "Select from a list of animation presets and apply it to the selected bone",
	"menu.brush_presets.pixel_perfect": "Pixel-perfect Brush",
	"panel.layers": "Layers",
	"uv_editor.copy_paste_tool.to_layer": "To New Layer",
	"format.image.new": "Create New Image",
	"format.image.info.summary": "The 2D Image editor lets you create and edit images and pixel art directly in Blockbench, without the need for an external image editor. Edit images, modify textures, or create your own pixel art!",
	"settings.move_with_selection_tool": "Use Selection Tool to Move Selections",
	"settings.move_with_selection_tool.desc": "Allow the Selection Tool to directly move selections, without having to switch to the Move Layer tool",
	"settings.final_newline": "Final Newline",
	"settings.final_newline.desc": "Insert a newline character at the end of exported files",
	"action.crop_layer_to_selection": "Crop Layer to Selection",
	"action.edit_mode_uv_overlay.desc": "Display the UV map overlay for all elements in edit mode",
	"menu.image": "Image",
	"menu.texture.discard_changes": "Discard Changes",
	"menu.texture.discard_changes.desc": "Discard all unsaved changes and load the latest version from the file",
	"panel.textures.images": "Images",
	"dialog.advanced": "Advanced",
	"dialog.recommended_option": "recommended",
	"modifier_actions.snap_to_center": "Snap to Center",
	"modifier_actions.snap_to_pixels": "Snap to Pixels",
	"message.invalid_format.install_plugin": "Install plugin '%0'",
	"message.plugin_deprecated.message": "Are you sure you want to install this deprecated plugin?",
	"message.plugin_deprecated.install_anyway": "Install Anyway",
	"message.image_editor.not_found": "Could not find the selected image editor. Please select a different option.",
	"message.knife_tool.confirm": "Press %0 or click here to apply Knife Tool",
	"message.knife_tool.skipped_face": "Cannot cut between different faces. Include the edges or vertices between them!",
	"message.optimize_animation.keyframes_removed": "Removed %0 redundant keyframes",
	"message.optimize_animation.nothing_to_optimize": "Found nothing to optimize!",
	"message.duplicate_bone_copy_animation.title": "Copy Animation",
	"message.duplicate_bone_copy_animation.message": "The duplicated bone is animated in %0 animations. Do you want to copy the keyframes over to the new bone?",
	"message.auto_fix_mesh_edit.title": "Auto Fix",
	"message.auto_fix_mesh_edit.revert": "Revert Edit",
	"message.auto_fix_mesh_edit.overlapping_vertices": "Certain vertices have been moved into the same spot. How would you like to proceed?",
	"message.auto_fix_mesh_edit.concave_quads": "One or more quad faces are now concave, which can cause issues in UV-mapping and rendering. Blockbench can automatically fix it for you:",
	"message.auto_fix_mesh_edit.merge_vertices": "Merge Vertices",
	"message.auto_fix_mesh_edit.split_quads": "Split Quads",
	"message.load_images.add_image": "Add Image",
	"dialog.project.modded_entity_entity_class": "Entity Class",
	"dialog.resize_texture.offset": "Offset",
	"dialog.animated_texture_editor.code_reference": "Code Reference",
	"dialog.animated_texture_editor.code_reference.about": "This code to implement the texture animation was generated as a reference and does not necessarily work without modification. Check out the documentation to learn more.",
	"dialog.animated_texture_editor.code_reference.docs": "Documentation",
	"dialog.animated_texture_editor.reframe": "Reframe",
	"dialog.animated_texture_editor.stride": "Frame Size",
	"dialog.animated_texture_editor.frames": "Number of Frames",
	"dialog.animated_texture_editor.add_frame": "Add Frame",
	"dialog.animated_texture_editor.resize_frames": "Resize Frames...",
	"dialog.animated_texture_editor.apply": "Apply",
	"dialog.add_primitive.edge_size": "Edge Size",
	"dialog.change_animation_speed.speed": "Speed",
	"dialog.change_animation_speed.adjust_snapping": "Adjust Snapping",
	"dialog.optimize_animation.selection": "Selection",
	"dialog.optimize_animation.selection.selected_keyframes": "Selected Keyframes",
	"dialog.optimize_animation.selection.selected_animation": "Selected Animation",
	"dialog.optimize_animation.selection.all_animations": "All Animations",
	"dialog.optimize_animation.thresholds": "Threshold values",
	"dialog.import_obj.obj": "OBJ File",
	"dialog.import_obj.mtl": "MTL File",
	"dialog.import_obj.scale": "Scale",
	"layout.thumbnail": "Custom Thumbnail CSS",
	"settings.pixel_grid": "Pixel Grid",
	"settings.pixel_grid.desc": "Show texture pixel grid on elements in edit mode",
	"settings.image_editor_grid_size": "Image Editor Grid Size",
	"settings.image_editor_grid_size.desc": "Size of the large grid in the 2D image editor",
	"settings.ground_plane_double_side": "Ground Plane Double-sided",
	"settings.ground_plane_double_side.desc": "Make the ground plane visible from below",
	"settings.optifine_save_default_texture": "OptiFine JEM: Export selected texture",
	"settings.optifine_save_default_texture.desc": "Export the selected texture as the default texture of the model",
	"action.slider_color_select_threshold": "Color Select Threshold",
	"action.slider_color_select_threshold.desc": "How close the color of a neighboring pixel has to be to get selected by color or wand select",
	"action.stretch_tool": "Stretch",
	"action.stretch_tool.desc": "Tool to select and stretch elements",
	"action.knife_tool": "Knife Tool",
	"action.knife_tool.desc": "Tool to cut mesh faces into smaller pieces",
	"action.duplicate_project": "Duplicate Project",
	"action.duplicate_project.desc": "Creates a copy of the open project",
	"action.transform_space.parent": "Parent",
	"action.transform_pivot_space": "Pivot Transform Space",
	"action.solidify_mesh_selection": "Solidify Faces",
	"action.solidify_mesh_selection.desc": "Solidify the selected faces of the mesh",
	"action.animated_texture_editor": "Flipbook Editor...",
	"action.animated_texture_editor.desc": "Edit the flipbook animation of the selected texture",
	"action.center_individual_pivots": "Center Individual Pivots",
	"action.center_individual_pivots.desc": "Set the pivot point of each selected element to its center",
	"action.uv_cycle": "Cycle UV",
	"action.uv_cycle.desc": "Cycle through the order of UV vertices without changing the UV positions",
	"action.uv_cycle_invert": "Cycle Invert UV",
	"action.uv_cycle_invert.desc": "Reverse the order of UV vertices without changing the UV positions",
	"action.slider_animation_controller_speed": "Controller Playback Speed",
	"action.slider_animation_controller_speed.desc": "The playback speed of animation controllers in percent",
	"action.optimize_animation": "Optimize Animation",
	"action.optimize_animation.desc": "Optimize the current animation and reduce the keyframe count",
	"action.change_animation_speed": "Change Animation Speed...",
	"action.change_animation_speed.desc": "Change the speed of the selected animation",
	"timeline.select_particle_file": "Select Particle File",
	"timeline.select_sound_file": "Select Sound File",
	"menu.cube.texture.default": "Default",
	"menu.texture.particle.clear": "Stop using for Particles",
	"menu.texture.use_as_default": "Set as Default",
	"menu.texture.use_as_default.clear": "Unassign as Default",
	"menu.toolbar.overflow": "Toolbar Overflow",
	"edit.solidify_mesh_selection.thickness": "Thickness",
	"reference_image.sync_to_timeline": "Sync To Timeline",
	"reference_image.toggle_playback": "Play/Pause",
	"dialog.add_primitive.shape.beveled_cuboid": "Beveled Cuboid",
	"dialog.ignore_all": "Ignore All",
	"data.texture_group": "Texture Group",
	"data.animation": "Animation",
	"generic.on": "On",
	"generic.off": "Off",
	"format.free.info.3d_printing": "3D Printing",
	"message.invalid_file.merge_conflict": "The file contains unresolved Git merge conflicts.",
	"dialog.expand_texture_selection.radius": "Amount",
	"dialog.expand_texture_selection.corner": "Corner Shape",
	"dialog.expand_texture_selection.corner.round": "Round",
	"dialog.expand_texture_selection.corner.square": "Square",
	"dialog.expand_texture_selection.corner.manhattan": "Manhattan",
	"dialog.merge_animation.merge_target": "Merge into",
	"keybindings.variation_conflict": "Variation conflicts with the main keybinding",
	"settings.recovery_save_interval": "Recovery Point Save Interval",
	"settings.recovery_save_interval.desc": "Blockbench regularly saves the open project in the background to recover in case of a computer crash. Set the interval in seconds. Set to 0 to disable saving.",
	"settings.save_view_per_tab": "Save View per Tab",
	"settings.save_view_per_tab.desc": "Save the current view angle for each tab separately",
	"settings.inherit_parent_color": "Inherit Parent Color",
	"settings.inherit_parent_color.desc": "Set the marker color of a newly created element to the color of the parent instead of a random color",
	"keybind.preview_select.multi_select": "Multi-select",
	"keybind.preview_select.group_select": "Group-select",
	"keybind.preview_select.loop_select": "Loop-select",
	"action.fill_mode.selection": "Selection",
	"action.fill_mode.selected_elements": "Selected Elements",
	"action.image_tiled_view": "Tiled View",
	"action.image_tiled_view.description": "Enable the tiled view in the 2D editor",
	"action.image_onion_skin_view": "Image Editor Onion Skin",
	"action.image_onion_skin_view.description": "Enable the onion skin view in the 2D editor",
	"action.expand_texture_selection": "Expand Texture Selection",
	"action.expand_texture_selection.desc": "Expand or shrink the texture selection",
	"action.switch_tabs.reverse_order": "Reverse order",
	"action.save_project_incremental": "Save Project With Increment",
	"action.save_project_incremental.desc": "Saves the current model as a project file with an increment (ex: project_2.bbmodel)",
	"action.copy.multiple": "Copy All",
	"action.copy.multiple.desc": "Copy all available data individually",
	"action.paste.multiple": "Paste All",
	"action.randomize_marker_colors": "Randomize Marker Colors",
	"action.cube_light_emission": "Light Emission",
	"action.cube_light_emission.desc": "Change the emissiveness of the selected cubes, as a value between 0 and 15",
	"action.view_mode.colored_solid": "Solid with Marker Colors",
	"action.focus_on_selection.rotate_only": "Rotate only",
	"action.create_texture_group": "Create Texture Group",
	"action.create_texture_group.desc": "Create a group for your textures",
	"action.uv_maximize.all_faces": "Affect all faces",
	"action.retarget_animators": "Retarget Animations",
	"action.retarget_animators.desc": "Select which animator targets which bone or element",
	"action.merge_animation": "Merge Animation",
	"action.merge_animation.desc": "Merge the animation into another animation",
	"action.add_keyframe.reset_values": "With default values",
	"action.set_timeline_range_start": "Set Timeline Range Start",
	"action.set_timeline_range_start.desc": "Set the start point for a custom playback range in the animation timeline",
	"action.set_timeline_range_end": "Set Timeline Range End",
	"action.set_timeline_range_end.desc": "Set the end point for a custom playback range in the animation timeline",
	"action.disable_timeline_range": "Disable Timeline Range",
	"action.disable_timeline_range.desc": "Disable the custom playback range in the animation timeline",
	"menu.texture_group.resolve": "Resolve",
	"menu.image_tiled_view.mirrored": "Mirrored Edges",
	"menu.image_onion_skin_view.frame": "Frames",
	"menu.image_onion_skin_view.frame.last_viewed": "Last Viewed Frame",
	"menu.image_onion_skin_view.frame.previous": "Previous Frame",
	"menu.image_onion_skin_view.frame.next": "Next Frame",
	"menu.image_onion_skin_view.frame.both": "Previous + Next",
	"menu.image_onion_skin_view.display": "Display",
	"menu.image_onion_skin_view.display.pixels": "Smaller Pixels",
	"menu.image_onion_skin_view.display.transparent": "Transparent",
	"menu.image_onion_skin_view.above": "Display Above",
	"menu.animation.reload": "Reload",
	"switches.autouv.alt": "Relative",
	"display.rotation_pivot": "Rotation Pivot",
	"display.scale_pivot": "Scale Pivot",
	"display.reference.fox": "Fox",
	"display.reference.eating": "Eating",
	"preview_scene.sky": "Sky",
	"preview_scene.space": "Space",
	"preview_scene.minecraft_ocean": "Ocean",
	"message.import_palette.selection_only": "Selection only",
	"dialog.blend_transition_edit.ease_in_out": "Ease-in-out (%0)",
	"dialog.blend_transition_edit.generate": "Generate...",
	"dialog.blend_transition_edit.generate.learn_more": "More info and preview",
	"dialog.blend_transition_edit.generate.curve": "Easing Type",
	"dialog.blend_transition_edit.generate.steps": "Keyframes",
	"settings.fps_limit": "FPS Limit",
	"settings.fps_limit.desc": "Limit how many frames per second Blockbench renders. The actual frame rate is limited to what your device can display.",
	"settings.outliner_reveal_on_select": "Reveal Elements on Select",
	"settings.outliner_reveal_on_select.desc": "Reveal elements in the ouliner when selected",
	"settings.java_export_pivots": "Export Pivots in Java block/item models",
	"settings.java_export_pivots.desc": "Save pivot points in Java block/item models on cubes without rotation",
	"animation_controllers.state.blend_transition_curve": "Blend Transition Curve",
	"menu.slider.reset_vector": "Reset Vector",
	"dialog.blend_transition_edit.extended": "Extended Graph",
	"message.screenshot_too_large.title": "Screenshot Resolution Issue",
	"message.screenshot_too_large.message": "The screenshot could not be rendered successfully. Please try again with a lower resolution or without supersampling.",
	"message.rename_elements.numbering": "You can use special characters to generate sequential numbers: % to get the index of the element within its group, $ to get the index within the selection.",
	"generic.edit_externally": "Edit Externally",
	"message.settings_require_restart.title": "Restart Required",
	"message.settings_require_restart.message": "Some settings will only apply after restarting the program.",
	"message.settings_require_restart.restart_now": "Restart Now",
	"message.settings_require_restart.restart_later": "Restart Later",
	"message.classroom_mode.install_plugin": "Cannot install plugins in Classroom Mode",
	"dialog.collection.export_path": "Export Path",
	"dialog.collection.select_all": "Select All",
	"dialog.collection.select_none": "Select None",
	"dialog.collection.add_with_filter": "Add with Filter",
	"dialog.collection.remove": "Remove",
	"dialog.material_config.title": "Material Config",
	"dialog.material_config.color_value": "Color Value",
	"dialog.material_config.mer": "Metal-Emissive-Roughness",
	"dialog.material_config.mer_value": "MER Value",
	"dialog.material_config.depth_type": "Depth Type",
	"dialog.create_texture.disable_mirror_uv": "Disable UV Mirroring",
	"dialog.create_texture.disable_mirror_uv.desc": "Disable the UV Mirror option in Mirror Modeling to preserve separate UVs for each side of the model",
	"dialog.create_gif.turn.sync_to_anim_length": "Sync to animation length",
	"settings.category.controls": "Controls",
	"settings.classroom_mode": "Classroom Mode",
	"settings.classroom_mode.desc": "Restricts functionality such as installing plugins and removes links to social media",
	"settings.antialiasing_bleed_fix": "Fix anti-aliasing bleeding",
	"settings.antialiasing_bleed_fix.desc": "Fixes texture bleeding when using anti-aliasing. Potentially unsupported on older hardware.",
	"settings.tone_mapping": "Tone Mapping",
	"settings.tone_mapping.desc": "Approximation method for displaying high dynamic range on a standard screen for PBR rendering.",
	"settings.audio_scrubbing": "Timeline Scrubbing Audio",
	"settings.audio_scrubbing.desc": "Play short previews of the audio while scrubbing through time timeline",
	"settings.viewport_rotate_speed": "Viewport Rotate Speed",
	"settings.viewport_rotate_speed.desc": "Input sensitivity when rotating in the viewport",
	"settings.viewport_zoom_speed": "Viewport Zoom Speed",
	"settings.viewport_zoom_speed.desc": "Input sensitivity when zooming in the viewport",
	"settings.editor_2d_zoom_speed": "2D Editor Zoom Speed",
	"settings.editor_2d_zoom_speed.desc": "Input sensitivity when zooming in the UV and 2D paint editor",
	"category.select": "Select",
	"action.vertex_snap_mode.rotate": "Rotate",
	"action.export_image": "Export Image",
	"action.export_image.desc": "Export your texture as an image file",
	"action.apply_mirror_modeling": "Apply Mirror Modeling",
	"action.apply_mirror_modeling.desc": "Apply Mirror Modeling to the selection. All selected elements will be copied and flipped across the X axis.",
	"action.create_collection": "Create Collection",
	"action.create_collection.desc": "Create a collection out of the outliner selection",
	"action.set_collection_content_to_selection": "Set Collection Content to Selected",
	"action.set_collection_content_to_selection.desc": "Set the selected groups and elements as the content of the collection",
	"action.add_to_collection": "Add Selected to Collection",
	"action.add_to_collection.desc": "Add the selected groups and elements to the collection",
	"action.view_mode.material": "Material Preview",
	"action.create_material": "Create Material",
	"action.create_material.desc": "Create a new PBR material out of the selected texture",
	"action.generate_pbr_map": "Generate PBR Map...",
	"action.generate_pbr_map.desc": "Generate a PBR map (height map or metalness, emissiveness, roughness) from an existing texture",
	"menu.tools.main_tools": "Toolbox",
	"menu.view.panels": "Panels",
	"menu.texture.pbr_channel": "PBR Channel",
	"menu.texture.pbr_channel.color": "Color",
	"menu.texture.pbr_channel.normal": "Normal",
	"menu.texture.pbr_channel.height": "Height",
	"menu.texture.pbr_channel.mer": "MER (Metalness-Emissive-Roughness)",
	"menu.texture.pbr_channel.mer_subsurface": "MER Subsurface",
	"menu.collection.export_project": "Export Project",
	"menu.collection.export_as": "Export as \"%0\"",
	"menu.panel.enable": "Enable",
	"menu.panel.move_to": "Move To",
	"menu.panel.move_to.left_bar": "Left Sidebar",
	"menu.panel.move_to.right_bar": "Right Sidebar",
	"menu.panel.move_to.top": "Top",
	"menu.panel.move_to.bottom": "Bottom",
	"menu.panel.move_to.float": "Float",
	"menu.panel.move_to.hidden": "Hide",
	"menu.panel.fold": "Collapse",
	"menu.mirror_painting.texture_center": "Origin",
	"menu.mirror_modeling.mirror_uv": "Mirror UV",
	"menu.animation_onion_skin.frames": "Frames",
	"menu.animation_onion_skin.select": "Select",
	"menu.animation_onion_skin.previous": "Previous",
	"menu.animation_onion_skin.next": "Next",
	"menu.animation_onion_skin.previous_next": "Previous + Next",
	"menu.animation_onion_skin.count": "Count",
	"menu.animation_onion_skin.interval": "Interval",
	"menu.animation_onion_skin_selective": "Selective Onion Skin",
	"menu.animation_onion_skin_selective.desc": "Only display onion skin for the selected part of the model",
	"edit.loop_cut.unit": "Unit",
	"edit.loop_cut.unit.size_units": "Size Units",
	"edit.loop_cut.unit.percent": "Percent",
	"edit.extrude_mesh_selection.direction": "Direction",
	"edit.extrude_mesh_selection.direction.outwards": "Outwards",
	"edit.extrude_mesh_selection.direction.average": "Average",
	"edit.extrude_mesh_selection.even_extend": "Even Extend",
	"edit.vertex_snap.align": "Align",
	"edit.vertex_snap.align.longest": "Longest Axis",
	"edit.vertex_snap.align.direction": "Direction from Pivot",
	"edit.vertex_snap.align.align_axis": "%0 Axis",
	"edit.vertex_snap.ignore_axis": "Ignore Axis",
	"codec.common.format": "Format",
	"codec.image.quality": "Quality",
	"panel.collections": "Collections",
	"modifier_actions.always": "Always Enabled",
	"modifier_actions.unless": "Unless %0",
	"settings.undo_selections": "Undo Selection",
	"settings.undo_selections.desc": "Track selection changes as a step in the undo history",
	"action.focus_on_selection.zoom": "Zoom to fit",
	"display.reference.tooting": "Horn Tooting",
	"settings.selection_tolerance": "Selection Tolerance",
	"settings.selection_tolerance.desc": "Size of the area that can be clicked to select an edge or vertex",
	"action.delete.keep_vertices": "Keep Edges/Vertices",
	"menu.mesh": "Mesh",
	"dialog.material_config.subsurface": "Subsurface Scattering",
	"dialog.material_config.subsurface_enabled.desc": "Use the MER map alpha channel for subsurface scattering",
	"settings.pick_combined_color": "Pick Combined Color",
	"settings.pick_combined_color.desc": "Pick the combined color of all layers at the respective pixel, instead of the color on the active layer",
	"action.split_rgb_into_layers": "Split RGBA Channels into Layers",
	"action.split_rgb_into_layers.desc": "Split the texture into additive layers, one for each RGBA channel",
	"dialog.project.java_block_version": "Format Version",
	"data.spline_mesh": "Spline",
	"data.billboard": "Billboard",
	"data.armature": "Armature",
	"data.armature_bone": "Armature Bone",
	"generic.reload": "Reload",
	"modifier_actions.subtract": "Subtract",
	"modifier_actions.reduced_intensity": "Fine-Tune",
	"modifier_actions.select_bone": "Select Bone",
	"modifier_actions.spline_select_multiple_points": "Select multiple Points or Handles",
	"modifier_actions.move_panel_without_docking": "Move without docking",
	"message.save_all_textures.message": "Do you want to save each of the following textures?",
	"message.save_all_textures.skip": "Skip",
	"dialog.add_spline.shape": "Shape",
	"dialog.add_spline.shape.segment": "Segment",
	"dialog.add_spline.shape.square": "Rectangle",
	"dialog.add_spline.shape.circle": "Circle",
	"dialog.add_spline.diameter": "Diameter",
	"dialog.add_spline.sides_tubular": "Tube Segments",
	"dialog.add_spline.sides_radial": "Ring Segments",
	"dialog.add_spline.radius": "Tube Radius",
	"dialog.add_spline.length": "Length",
	"dialog.add_spline.width": "Width",
	"dialog.plugins.revoke_permissions": "Revoke Permissions",
	"dialog.expression_editor.pretty_print": "Pretty Print",
	"dialog.expression_editor.minify": "Minify",
	"dialog.expression_editor.find_replace": "Find/Replace",
	"dialog.create_gif.show_gizmos": "Record Gizmos & Grid",
	"dialog.preview_options.title": "Preview Options",
	"dialog.preview_options.background": "Background",
	"dialog.preview_options.background.checkerboard": "Checkerboard",
	"dialog.preview_options.background.solid": "Solid",
	"dialog.preview_options.background.custom_color": "Custom Color",
	"dialog.preview_options.show_gizmos": "Show Gizmos",
	"dialog.skin.texture_source": "Texture Source",
	"dialog.skin.texture_source.template": "Generate Template",
	"dialog.skin.texture_source.load_texture": "Load from Minecraft",
	"dialog.skin.texture_file": "Texture File",
	"dialog.convert_skin.adjust_texture": "Adjust Texture",
	"dialog.settings.clear_profile_value": "Clear profile value",
	"layout.section.customize": "Customize",
	"layout.theme.configure": "Configure",
	"layout.color.elevated": "Elevated",
	"layout.color.elevated.desc": "Elevated UI elements, usually separated by drop shadow",
	"layout.file.watch_changes": "Watch Changes and Reload",
	"settings.autocomplete_code": "Autocomplete Code",
	"settings.autocomplete_code.desc": "Display autocomplete suggestions in code editors",
	"settings.detect_flipbook_textures": "Detect Flipbook Textures",
	"settings.detect_flipbook_textures.desc": "Automatically detect flipbook animated textures and preview them as animation",
	"settings.double_click_select_reference": "Select Reference Image on Double Click",
	"settings.double_click_select_reference.desc": "Double click the viewport to select a reference image",
	"settings.default_keyframe_interpolation": "Default Keyframe Interpolation",
	"settings.default_keyframe_interpolation.desc": "Select the default keyframe interpolation mode",
	"settings.color_picker_style": "Color Picker Style",
	"settings.color_picker_style.desc": "Select the style of the paint mode color picker",
	"settings.export_asset_paths": "Export Asset Paths",
	"settings.export_asset_paths.desc": "Select how paths to assets such as textures or animations get saved in .bbmodel files",
	"settings.export_asset_paths.relative": "Relative Paths",
	"settings.export_asset_paths.absolute": "Full Paths",
	"settings.export_asset_paths.both": "Relative & Full Paths (Texture only)",
	"settings.export_asset_paths.none": "No Export",
	"action.slider_spline_resolution": "Spline Resolution %0",
	"action.slider_spline_resolution.desc": "Change spline resolution on the %0 axis (%1)",
	"action.slider_spline_resolution.u.desc_precision": "Ring Segments",
	"action.slider_spline_resolution.v.desc_precision": "Tube Segments",
	"action.slider_spline_radius": "Spline Radius",
	"action.slider_spline_radius.desc": "Change spline Radius",
	"action.slider_spline_handle_tilt": "Handle Tilt",
	"action.slider_spline_handle_tilt.desc": "Change spline handle Tilt",
	"action.slider_spline_handle_size": "Handle Size",
	"action.slider_spline_handle_size.desc": "Change spline handle Size",
	"action.blend_mode.lighten": "Lighten",
	"action.blend_mode.darken": "Darken",
	"action.weight_brush": "Weight Brush",
	"action.weight_brush.desc": "Paint vertex weights on meshes for armature deformations",
	"action.convert_minecraft_skin_variant": "Convert Slim/Wide Skin",
	"action.convert_minecraft_skin_variant.desc": "Switch the skin model between the classic wide (steve) model and the slim (alex) model. Optionally auto-adjust the texture to fit the model",
	"action.custom_skin_poses": "Custom Skin Poses",
	"action.custom_skin_poses.desc": "Load a custom skin pose preset",
	"action.custom_skin_poses.update": "Update Pose",
	"action.custom_skin_poses.update.desc": "Overwrite the saved pose with the current pose of the model",
	"action.add_custom_skin_pose": "Add Custom Skin Pose",
	"action.add_custom_skin_pose.desc": "Save the current pose of the model as a pose preset",
	"action.export_stl": "Export STL",
	"action.export_stl.desc": "Export a STL model for 3D printing",
	"action.add_element": "Add Element",
	"action.add_element.desc": "Add a new element from the list of element types",
	"action.add_spline": "Add Spline",
	"action.add_spline.desc": "Adds a new spline",
	"action.add_billboard": "Add Billboard",
	"action.add_billboard.desc": "Adds a new billboard, a flat element that always faces towards the camera",
	"action.add_armature": "Add Armature",
	"action.add_armature.desc": "Adds an armature that allows deforming a mesh via animation",
	"action.add_armature_bone": "Add Armature Bone",
	"action.add_armature_bone.desc": "Adds a bone to the armature",
	"action.search_textures": "Search Textures",
	"action.search_textures.desc": "Search for textures by name",
	"action.search_animations": "Search Animations",
	"action.search_animations.desc": "Search for animations by name",
	"action.spline_selection_mode": "Spline Selection Mode",
	"action.spline_selection_mode.object": "Object",
	"action.spline_selection_mode.handles": "Handles",
	"action.spline_render_mode": "Geometry",
	"action.spline_render_mode.mesh": "Mesh",
	"action.spline_render_mode.path": "Path",
	"action.spline_render_mode.desc": "Which geometry this spline should render",
	"action.spline_uv_mode": "UV Style",
	"action.spline_uv_mode.length_accurate": "Length Accurate",
	"action.spline_uv_mode.uniform": "Uniform",
	"action.spline_uv_mode.per_segment": "Per Segment",
	"action.spline_uv_mode.desc": "How the spline's tube mesh should lay its UVs",
	"action.spline_ring_segments": "Ring Segments",
	"action.spline_ring_segments.desc": "How many subdivisions this Spline has per Tube Ring",
	"action.spline_tube_segments": "Tube Segments",
	"action.spline_tube_segments.desc": "How many subdivisions this Spline has along its path",
	"action.spline_tube_radius": "Tube Radius",
	"action.spline_tube_radius.desc": "Set the Spline's Tube Radius",
	"action.spline_display_space": "Display Space",
	"action.spline_display_space.desc": "Display spline space indicators on its path",
	"action.spline_handle_mode": "Spline Handle Mode",
	"action.spline_handle_mode.desc": "Which mode to use for transforming spline handles",
	"action.spline_handle_mode.aligned": "Aligned",
	"action.spline_handle_mode.free": "Free",
	"action.spline_handle_mode.mirrored": "Mirrored",
	"action.slider_weight_brush_size": "Weight Brush Size",
	"action.weight_brush_xray": "Weight Brush XRay Mode",
	"action.weight_brush_xray.desc": "When enabled, the weight brush will affect all vertices instead of just the ones that are visible on the surface",
	"action.apply_spline_rotation": "Apply Rotation",
	"action.apply_spline_rotation.desc": "Reset the element rotation of the spline, and apply it to the geometry instead",
	"action.extrude_spline_selection": "Extrude Spline",
	"action.extrude_spline_selection.desc": "Extrude the selected handle on all splines",
	"action.split_spline": "Split Spline",
	"action.split_spline.desc": "Splits the spline into two splines at the selected handle",
	"action.divide_spline_curve": "Divide Spline Segment",
	"action.divide_spline_curve.desc": "Splits the spline segment into two new segments with a new handle at their intersection",
	"action.set_vertex_weights": "Set Vertex Weights",
	"action.set_vertex_weights.desc": "Set the vertex weights of the selected vertices to a specific value on a certain armature bone",
	"action.calculate_vertex_weights": "Calculate Vertex Weights",
	"action.calculate_vertex_weights.desc": "Automatically assign vertex weights weights based on the position of the bones",
	"action.shelf_alignment": "Shelf Alignment",
	"action.shelf_alignment.desc": "Select the vertical alignment of items on the shelf",
	"action.shelf_alignment.top": "Top Alignment",
	"action.shelf_alignment.bottom": "Bottom Alignment",
	"action.view_mode.vertex_weight": "Vertex Weight",
	"action.view_mode.weighted_bone_colors": "Vertex Bone Colors",
	"action.create_animation_group": "Create Animation Group",
	"action.create_animation_group.desc": "Create a group of animations",
	"action.move_graph_keyframes_up": "Move Keyframe Graph Up",
	"action.move_graph_keyframes_down": "Move Keyframe Graph Down",
	"menu.skin": "Skin",
	"menu.text_edit.expression_editor": "Expression Editor",
	"menu.color_picker.picker_type.normal": "Normal Map",
	"menu.texture.flipbook_animation": "Flipbook Animation",
	"menu.panel.attach_to": "Attach To",
	"menu.animation.playing": "Playing",
	"menu.animation_file.save_as": "Save As",
	"menu.animator.quaternion_interpolation": "Quaternion Interpolation",
	"edit.extrude_spline_selection.extend": "Extend",
	"edit.divide_spline_curve.position": "Position",
	"group.bedrock_binding": "Binding",
	"group.cem_attach": "CEM Attach",
	"group.cem_model": "CEM Model",
	"group.cem_scale": "CEM Scale",
	"cube.rescale": "Rotation Rescale",
	"cube.rescale.desc": "Rescale cube to compensate for the rotation angle",
	"mesh.shading": "Shading",
	"mesh.shading.flat": "Flat",
	"mesh.shading.smooth": "Smooth",
	"spline_mesh.cyclic": "Cyclic",
	"spline_mesh.cyclic.desc": "Whether the selected spline should form a loop (Cycle)",
	"billboard.offset": "Offset",
	"billboard.facing_mode": "Facing Mode",
	"billboard.facing_mode.lookat": "Look At",
	"billboard.facing_mode.lookat_y": "Look At Y",
	"billboard.facing_mode.rotate": "Rotate",
	"billboard.facing_mode.rotate_y": "Rotate Y",
	"armature_bone.connected": "Connected",
	"reference_image.blueprint": "Locked Blueprint",
	"codec.image.alpha_channel": "Alpha Channel",
	"codec.image.animation_fps": "Animation FPS",
	"panel.palette": "Palette",
	"panel.keyframe.change_effect_file": "Change Effect File",
	"panel.transform": "Transform",
	"panel.element.spline_dimensions": "Spline Dimensions",
	"display.slot.on_shelf": "Shelf",
	"display.reference.shelf": "Shelf (All Slots)",
	"display.reference.shelf_left": "Shelf (Left Slot)",
	"display.reference.shelf_center": "Shelf (Center Slot)",
	"display.reference.shelf_right": "Shelf (Right Slot)",
	"message.newer_project_format_version.title": "Outdated client",
	"message.newer_project_format_version.message": "This file was saved in a newer version of Blockbench. Update to Blockbench %0 or newer to be able to open it correctly",
	"message.load_images.add_layer": "Add as Layer",
	"message.load_images.category.add_to_project": "Add to project",
	"message.load_images.category.new_project": "New project",
	"message.load_palette.title": "Load Palette",
	"message.load_palette.message": "Are you sure you want to load this palette? This will replace your current color palette.",
	"dialog.set_vertex_weights.weight": "Weight",
	"dialog.set_vertex_weights.overwrite": "Overwrite other bones",
	"action.element_render_order.short": "Render Order",
	"action.element_render_order.desc": "Render order of elements. This can help fix elements that are hidden behind other elements with transparent textures. Leave it on Auto for opaque elements.",
	"spline.shading.flat": "Flat",
	"spline.shading.smooth": "Smooth",
	"spline.shading": "Shading",
	"spline.shading.desc": "How this spline's tube should be shaded",
	"action.slider_weight_brush_limit": "Weight Brush Limit",
	"action.slider_weight_brush_limit.desc": "Set an upper limit for how much weight the weight brush can assign to a vertex",
	"action.weight_brush_blend_mode": "Weight Brush Blend Mode",
	"action.weight_brush_blend_mode.set": "Set",
	"action.weight_brush_blend_mode.add": "Add",
	"action.apply_texture_to_elements": "Apply Texture to Elements",
	"action.apply_texture_to_elements.desc": "Apply the selected texture to the selected elements",
	"menu.panel.reset_size": "Reset Size",
	"action.import_layer": "Import Layer",
	"action.import_layer.desc": "Import image files as layers",
	"menu.collection.open_file": "Open File",
	"layout.version": "Version",
	"settings.status_bar_transform_sliders": "Transform Sliders in Status Bar",
	"settings.status_bar_transform_sliders.desc": "Display the transform sliders toolbar of the selected tool in the status bar instead of using the Transform panel",
	"settings.default_bedrock_format": "Default Bedrock Format",
	"settings.default_bedrock_format.desc": "Select the default format to load Minecraft Bedrock models in, when no specific format can be detected from context.",
	"settings.limit_brush_opacity_per_stroke": "Limit Brush Opacity per Stroke",
	"settings.limit_brush_opacity_per_stroke.desc": "Limit the opacity that a brush can apply to the value of the opacity slider during each brush stroke. With a smooth brush this behavior can potentially lead to slight unwanted noise.",
	"action.merge_splines": "Merge Splines",
	"action.merge_splines.desc": "Merge multiple splines into one",
	"settings.default_java_block_version": "Default Java Block/Item Version",
	"settings.default_java_block_version.desc": "Default format version when creating new Java block/item models or opening files without format version",
	"data.bounding_box": "Bounding Box",
	"keys.option": "Option",
	"keys.slide_lmb_horizontal": "Left-click slide horizontal",
	"keys.slide_lmb_vertical": "Left-click slide vertical",
	"keys.slide_rmb_horizontal": "Right-click slide horizontal",
	"keys.slide_rmb_vertical": "Right-click slide vertical",
	"message.recover_backup.unknown_project": "Unknown project",
	"message.recover_backup.discard_others": "Discard all others",
	"message.unsupported_file_extension.title": "File format not supported",
	"message.unsupported_file_extension.message": "Cannot open file %0, the format is not supported. You might need a plugin for this file type.",
	"message.unsupported_file_extension.open_in_default_program": "Open in default program",
	"dialog.project.uv_size": "UV Size",
	"dialog.collection.offset": "Offset",
	"dialog.texture.fps": "FPS",
	"dialog.texture.fps.desc": "Frames per second of the texture flipbook animation",
	"dialog.edit_uv_size.title": "Edit UV Size",
	"dialog.edit_uv_size.target": "Target",
	"dialog.edit_uv_size.adjust": "Adjust",
	"dialog.edit_uv_size.adjust.adjust_uv": "Counter UV",
	"dialog.edit_uv_size.adjust.adjust_scale": "Counter UV & Scale",
	"dialog.edit_uv_size.adjust.keep": "Keep UV",
	"dialog.edit_uv_size.target_size": "Target UV Size",
	"dialog.edit_uv_size.preset.original": "Original",
	"dialog.edit_uv_size.preset.match_texture": "Match Texture",
	"dialog.edit_uv_size.result": "Result",
	"dialog.edit_uv_size.result.textures": "Textures",
	"dialog.adjust_brightness_contrast.brightness": "Brightness",
	"dialog.adjust_brightness_contrast.contrast": "Contrast",
	"dialog.adjust_saturation_hue.saturation": "Saturation",
	"dialog.adjust_saturation_hue.hue": "Hue",
	"dialog.adjust_opacity.mode": "Mode",
	"dialog.adjust_opacity.mode.multiply": "Multiply",
	"dialog.adjust_opacity.mode.set": "Set",
	"dialog.bedrock_bounding_box.type": "Type",
	"dialog.bedrock_bounding_box.type.collision_box": "Collision",
	"dialog.bedrock_bounding_box.type.selection_box": "Selection Box",
	"dialog.bedrock_bounding_box.type.hitbox": "Hitbox",
	"dialog.bedrock_bounding_box.hitbox_note": "Please note that entity hitboxes only work up to a certain size and may not adapt to the rotation of the entity in-game.",
	"dialog.bedrock_bounding_box.collision_note": "Please note that entity collision boxes only support one centered shape with a square top profile.",
	"dialog.bedrock_bounding_box.no_bounding_boxes": "No bounding boxes exist in this project",
	"dialog.install_plugins_from_list.ids": "Plugin IDs",
	"dialog.install_plugins_from_list.info": "Install several plugins from a list of IDs. Before installing, please ensure that you actually need all plugins. Keeping inactive plugins can increase the risk of bugs and incompatibilities with future updates.",
	"dialog.copy_installed_plugins.details": "Include Details",
	"dialog.flip_animation.phase_offset": "Phase Offset",
	"dialog.flip_animation.phase_offset.off": "Off",
	"dialog.flip_animation.phase_offset.custom": "Custom",
	"dialog.flip_animation.clear_opposite": "Overwrite opposite",
	"settings.flipbook_textures_in_animation": "Play Flipbook Textures in Animation",
	"settings.flipbook_textures_in_animation.desc": "Preview animations on flipbook textures in sync with the animation timeline",
	"settings.display_uv": "Display UV Faces",
	"settings.display_uv.desc": "Select which UV faces are displayed in the UV editor",
	"settings.display_uv.selected_faces": "Only selected faces",
	"settings.display_uv.selected_elements": "All faces on selected elements",
	"settings.display_uv.all_elements": "All faces on all elements",
	"settings.local_position_values": "Local Position Values",
	"settings.local_position_values.desc": "Display all position values in the Transform panel in local space",
	"settings.transform_cube_from_center": "Transform Cubes from Center",
	"settings.transform_cube_from_center.desc": "Edit the cube position values from the center instead of the corner",
	"settings.color_picker_tool_switch": "Color Picker Tool Switch",
	"settings.color_picker_tool_switch.desc": "When picking a transparent pixel, switch to the eraser. When the eraser was previously selected and a color is picked, switch to the brush",
	"keybind.preview_scroll_zoom": "Zoom View",
	"keybind.uv_editor_scroll_zoom": "Zoom UV/2D Editor",
	"action.blend_mode.alpha_mask": "Alpha Mask",
	"action.swap_tools.hold": "Hold to swap (Color Picker)",
	"action.import_bedrock_voxel_shape": "Import Bedrock Voxel Shape",
	"action.import_bedrock_voxel_shape.desc": "Add a voxel shape from a json file to the current project",
	"action.export_bedrock_voxel_shape": "Export Bedrock Voxel Shape",
	"action.export_bedrock_voxel_shape.desc": "Export the bounding boxes in the project as a bedrock voxel shape file",
	"action.plugins_window_menu": "Menu",
	"action.copy_installed_plugins": "Copy Installed Plugins",
	"action.copy_installed_plugins.desc": "Generate and copy a list of the currently installed plugins",
	"action.install_plugins_from_list": "Install Plugins from List",
	"action.install_plugins_from_list.desc": "Install plugins from a list of plugin IDs",
	"action.add_bounding_box": "Add Bounding Box",
	"action.add_bounding_box.desc": "Adds a new bounding box",
	"action.split_alpha_into_layer": "Split Alpha Channel into Layer",
	"action.split_alpha_into_layer.desc": "Split the alpha channel of the texture into an alpha mask layer",
	"action.generate_bedrock_block_box": "Copy Collision/Selection Component",
	"action.generate_bedrock_block_box.desc": "Generate a collision or selection box component for Minecraft Bedrock Edition blocks",
	"action.generate_bedrock_entity_box": "Copy Collision/Hitbox Component",
	"action.generate_bedrock_entity_box.desc": "Generate a collision or custom hit test component for Minecraft Bedrock Edition entities",
	"action.refresh_texture": "Refresh Texture",
	"action.refresh_texture.desc": "Reload the texture from file",
	"action.move_uv_to_cursor": "Move UV to Cursor",
	"action.move_uv_to_cursor.desc": "Move the selected UV faces to the mouse cursor position",
	"action.edit_mode_uv_overlay": "Display All Elements",
	"action.round_keyframe_values": "Round Keyframe Values",
	"action.round_keyframe_values.desc": "Round all values of the selected keyframes",
	"action.keyframe_column_create.all_channels": "All Channels",
	"action.keyframe_column_create.all_channels.desc": "Initialize all channels with keyframes even if they had no keyframes previously",
	"action.add_all_to_timeline": "Add All to Timeline",
	"action.mirror_animating": "Mirror Animating",
	"action.mirror_animating.desc": "Mirror animation edits to the opposite side",
	"action.copy_animation_pose": "Copy Animation Pose",
	"action.copy_animation_pose.desc": "Copy all keyframes to replicate the current animation pose",
	"menu.texture.file_format": "File Format",
	"menu.texture.wrap_mode": "Wrap Mode",
	"menu.texture.wrap_mode.limited": "Restricted",
	"menu.texture.wrap_mode.repeat": "Repeat",
	"menu.texture.wrap_mode.clamp": "Clamp Edge",
	"edit.reparent_selection.adjust_position": "Preserve World Transform",
	"texture_mesh.texture_name": "Texture Name",
	"display.slot.embedded": "Embedded",
	"display.animate_preview": "Preview Animation",
	"display.reference.flower_pot": "Flower Pot",
	"data.generated_item_mesh": "Generated Item Model",
	"message.generated_item_model.title": "Generated Item Model",
	"message.generated_item_model.message": "This model has no elements of its own. Minecraft builds the item shape from the model's texture, so what you see here is only a preview of that shape. It cannot be edited, and is not exported.\n\nTo change how the item looks in game, edit the texture.",
	"message.generated_item_model.edit_texture": "Edit Texture",
	"message.generated_item_model.convert": "Convert to Editable Model",
	"message.convert_generated_item_model.title": "Convert to Editable Model",
	"message.convert_generated_item_model.message": "This builds real elements by extruding the texture, so you can change the item shape in 3D.\n\nIf you only want to change how the item looks, you do not need this. Edit the texture instead, and Minecraft will keep generating the shape from it.",
	"message.convert_generated_item_model.confirm": "Extrude Texture",
	"message.generated_item_model_conflict.title": "Generated Item Model",
	"message.generated_item_model_conflict.message": "Minecraft cannot use both a generated item model and elements. Now that this model has elements, the generated shape is ignored in game.",
	"message.generated_item_model_conflict.convert": "Convert the Generated Model to Cubes",
	"message.generated_item_model_conflict.convert.desc": "Extrude the texture into real elements, so nothing is lost",
	"message.generated_item_model_conflict.remove": "Remove the Generated Model",
	"message.generated_item_model_conflict.remove.desc": "Delete the preview and model the item from scratch",
	"message.generated_item_model_conflict.keep": "Keep It as a Reference",
	"message.generated_item_model_conflict.keep.desc": "Show it in Blockbench only, never exported",
	"message.add_reference_image.globally": "Add for all projects",
	"dialog.extrude.orientation.upright_z": "Upright Z",
	"dialog.extrude.depth": "Depth",
	"dialog.add_primitive.shape.icosphere": "Icosphere",
	"dialog.add_primitive.shape.octahedron": "Octahedron",
	"dialog.add_primitive.shape.dodecahedron": "Dodecahedron",
	"dialog.add_primitive.detail": "Detail",
	"dialog.plugins.update": "Update",
	"dialog.plugins.update_available": "Update Available",
	"dialog.create_variable_placeholder.variable": "Variable",
	"dialog.create_variable_placeholder.type": "Type",
	"dialog.create_variable_placeholder.type.value": "Value",
	"dialog.create_variable_placeholder.type.slider": "Slider",
	"dialog.create_variable_placeholder.type.toggle": "Toggle",
	"dialog.create_variable_placeholder.type.impulse": "Impulse",
	"dialog.create_variable_placeholder.value": "Value",
	"dialog.create_variable_placeholder.duration": "Duration",
	"dialog.create_variable_placeholder.step": "Step",
	"dialog.create_variable_placeholder.range": "Range",
	"dialog.create_variable_placeholder.output": "Output",
	"dialog.view_built_in_variables.function": "Parameters required",
	"dialog.advanced_screenshot.export": "Export",
	"dialog.preview_options.show_element_markers": "Show Element Markers",
	"dialog.preview_options.show_element_markers.desc": "Display markers to indicate the position for elements such as bones, null objects, and locators",
	"settings.maximum_zoom_distance": "Maximum Zoom Distance",
	"settings.maximum_zoom_distance.desc": "How far the camera can be zoomed away from the model",
	"settings.constant_outlines": "Constant Outlines",
	"settings.constant_outlines.desc": "Always display element outlines regardless of selection",
	"settings.new_project_dialog": "New Project Dialog",
	"settings.new_project_dialog.desc": "Show the Project dialog when creating a new project",
	"settings.opacity_range": "Opacity Range",
	"settings.opacity_range.desc": "Select which range is used to control opacity of layers and brushes",
	"settings.automatic_plugin_updates": "Automatic Plugin Updates",
	"settings.automatic_plugin_updates.desc": "Automatically update plugins to keep them up-to-date",
	"settings.native_window_frame": "Native Window Frame",
	"settings.native_window_frame.desc": "Use a native window frame in the style of the OS",
	"keybind.preview_scroll_pan": "Scroll Pan View",
	"keybind.preview_scroll_pan.desc": "Use scroll to pan the view, can be used for two-finger panning with trackpads",
	"action.position_slider_per_element": "Move Individual Positions",
	"action.position_slider_per_element.desc": "When enabled, using the position sliders changes individual positions per element. When disabled, the whole selection moves in the selected transform space.",
	"action.origin_slider_direct_values": "Move Pivot Values Directly",
	"action.origin_slider_direct_values.desc": "When enabled, pivot sliders will move the pivot point directly, affecting the position of the object. When disabled, positions get adjusted automatically.",
	"action.brush_lock_mode": "Brush Lock Mode",
	"action.brush_lock_mode.none": "Unlocked",
	"action.brush_lock_mode.element": "Lock to Element",
	"action.brush_lock_mode.face": "Lock to Face",
	"action.slider_brush_aspect_ratio": "Brush Aspect Ratio",
	"action.slider_brush_aspect_ratio.desc": "Aspect ratio of the brush",
	"action.screen_space_brush_projection": "Screen Space Brush Projection",
	"action.screen_space_brush_projection.desc": "Use screen space projection for painting with a brush",
	"action.close_other_projects": "Close Other Tabs",
	"action.close_other_projects.desc": "Closes all projects except the open project",
	"action.close_projects_to_right": "Close Tabs to the Right",
	"action.close_projects_to_right.desc": "Closes all project tabs to the right of the open project",
	"action.extrude_texture_to_model": "Extrude Texture",
	"action.extrude_texture_to_model.desc": "Generate a model by extruding this texture",
	"action.experimental_settings": "Experimental Settings",
	"action.experimental_settings.desc": "Customize experimental developer settings",
	"action.convert_texture_mesh_to_cubes": "Convert to Extruded Model",
	"action.convert_texture_mesh_to_cubes.desc": "Replace the texture mesh with cubes extruded from its texture, in the same place",
	"action.flip_in_place": "Flip in Place %0",
	"action.flip_in_place.desc": "Flip the selected elements on the %0 axis in its current position",
	"action.create_layer_group": "Create Layer Group",
	"action.resolve_layer_group": "Resolve Layer Group",
	"action.preview_models": "Preview Models",
	"action.preview_models.desc": "Select and edit reference models",
	"action.keyframe_select_before_playhead": "Select Keyframes Before Playhead",
	"action.keyframe_select_before_playhead.desc": "Select all keyframes in the timeline at or before the playhead",
	"action.keyframe_select_after_playhead": "Select Keyframes After Playhead",
	"action.keyframe_select_after_playhead.desc": "Select all keyframes in the timeline at or after the playhead",
	"action.set_ik_pole": "Set IK Pole",
	"action.set_ik_pole.desc": "Select the pole that the chain will attempt to face towards while moving",
	"action.create_variable_placeholder": "Create Variable Placeholder",
	"action.create_variable_placeholder.desc": "Add a variable to the variable placeholders list to preview a value",
	"action.view_built_in_variables": "View Built-in Variables",
	"action.view_built_in_variables.desc": "Display the list of variables and their values that Blockbench automatically provides for animation preview",
	"menu.paint": "Paint",
	"menu.brush_presets.screen_space": "Screen Space Brush",
	"edit.loop_cut.spacing": "Spacing",
	"edit.loop_cut.spacing.proportional": "Proportional",
	"edit.loop_cut.spacing.even_start": "Even - From Start",
	"edit.loop_cut.spacing.even_end": "Even - From End",
	"cube.shade_direction_override": "Shade Direction Override",
	"cube.shade_direction_override.desc": "Shade every face of the cube as if it was facing this direction. If not set, each face is shaded based on the direction it actually faces. This does not affect ambient occlusion or shading based on light level.",
	"null_object.ik_target": "IK Target",
	"null_object.ik_source": "IK Root",
	"null_object.ik_pole": "IK Pole",
	"reference_image.layer.scene": "3D Scene",
	"reference_image.view_mode": "View Mode",
	"reference_image.view_mode.flat_image": "Flat Image",
	"reference_image.cull_backface": "Hide Backside",
	"codec.common.merge_armature_mesh": "Merge Armature Mesh",
	"preview_model.transform": "Transform",
	"preview_model.reset_transform": "Reset Transform",
	"preview_model.minecraft_player": "Minecraft Player",
	"dialog.generate_pbr_map.channel": "PBR Channel",
	"dialog.generate_pbr_map.channel.metalness": "Metalness",
	"dialog.generate_pbr_map.channel.emissive": "Emissive",
	"dialog.generate_pbr_map.channel.roughness": "Roughness",
	"dialog.generate_pbr_map.method": "Source",
	"dialog.generate_pbr_map.method.value": "Value",
	"dialog.generate_pbr_map.method.brightness": "Brightness",
	"dialog.generate_pbr_map.method.saturation": "Saturation",
	"dialog.generate_pbr_map.method.hue": "Hue",
	"dialog.generate_pbr_map.method.red": "Red",
	"dialog.generate_pbr_map.method.green": "Green",
	"dialog.generate_pbr_map.method.blue": "Blue",
	"dialog.generate_pbr_map.method.empty": "Empty",
	"dialog.generate_pbr_map.in_range": "Input Range",
	"dialog.generate_pbr_map.out_range": "Output Range",
	"dialog.generate_pbr_map.invert": "Invert",
	"dialog.generate_pbr_map.preset": "Preset",
	"dialog.generate_pbr_map.preset.apply_preset": "Apply Preset",
	"dialog.generate_pbr_map.update_values": "Update with current values",
	"dialog.generate_pbr_map.preset.new_preset": "New Preset...",
	"action.image_editor_checkerboard": "Checkerboard",
	"action.image_editor_checkerboard.desc": "Toggle the checkerboard background of the 2D Editor",
	"message.child_model_only.resolve": "Resolve Parent Models",
	"message.child_model_only.resolve.desc": "Merge the whole parent chain into this model",
	"message.child_model_only.open.desc": "Open the parent in a new tab, keeping it separate from this model",
	"action.brush_lock_mode.selected_faces": "Lock to Selected Faces",
	"reference_image.view_mode.plane": "3D Plane",
	"preview_model.minecraft_crafting_table": "Minecraft Crafting Table",
	"dialog.extrude.animated": "Animated Texture",
	"dialog.scale.box_uv_warning_required": "Scaling cubes that use Box UV may break the UV mapping. Instead, try to scale your model during implementation, or use Inflate.",
	"menu.color_picker.picker_type.wheel_static": "Wheel (Static)"
}